import Vue from 'vue';
import Router from 'vue-router';
import store from "./store";

import Home from './views/Home/Home.vue';
import Mobile from './views/Home/Mobile.vue';
import InboxIndex from './views/Inbox/Index.vue';
import LoginIndex from './views/Login/Index.vue';

import ModuleInfoIndex from './views/ModuleInfo/Index.vue';
import ModuleInfoInput from './views/ModuleInfo/Input.vue';
import ModuleInfoDetail from './views/ModuleInfo/Detail.vue';

import JobConfigurationIndex from './views/JobConfiguration/Index.vue';
import JobConfigurationInput from './views/JobConfiguration/Input.vue';
import JobConfigurationDetail from './views/JobConfiguration/Detail.vue';

import SchedulerConfigurationIndex from './views/SchedulerConfiguration/Index.vue';
import SchedulerConfigurationInput from './views/SchedulerConfiguration/Input.vue';
import SchedulerConfigurationDetail from './views/SchedulerConfiguration/Detail.vue';

import RoleIndex from './views/Role/Index.vue';
import RoleInput from './views/Role/Input.vue';
import RoleDetail from './views/Role/Detail.vue';
import RoleIndexDetail from './views/Role/IndexDetail.vue';

import DownloadProcessIndex from './views/DownloadProcess/Index.vue';
import DownloadProcessInput from './views/DownloadProcess/Input.vue';
import DownloadProcessDetail from './views/DownloadProcess/Detail.vue';

import RoleManagementIndex from './views/RoleManagement/Index.vue';
import RoleManagementInput from './views/RoleManagement/Input.vue';
import RoleManagementDetail from './views/RoleManagement/Detail.vue';
import RoleManagementIndexDetail from './views/RoleManagement/IndexDetail.vue';

import FunctionInfoIndex from './views/FunctionInfo/Index.vue';
import FunctionInfoInput from './views/FunctionInfo/Input.vue';
import FunctionInfoDetail from './views/FunctionInfo/Detail.vue';

import ApprovalGroupIndex from './views/ApprovalGroup/Index.vue';
import ApprovalGroupInput from './views/ApprovalGroup/Input.vue';
import ApprovalGroupDetail from './views/ApprovalGroup/Detail.vue';

import ApprovalStateIndex from './views/ApprovalState/Index.vue';
import ApprovalStateInput from './views/ApprovalState/Input.vue';
import ApprovalStateDetail from './views/ApprovalState/Detail.vue';

import ApproverTypeIndex from './views/ApproverType/Index.vue';
import ApproverTypeInput from './views/ApproverType/Input.vue';
import ApproverTypeDetail from './views/ApproverType/Detail.vue';

import ApprovalStructureIndex from './views/ApprovalStructure/Index.vue';
import ApprovalStructureInput from './views/ApprovalStructure/Input.vue';
import ApprovalStructureDetail from './views/ApprovalStructure/Detail.vue';

import ActivityStateIndex from './views/ActivityState/Index.vue';
import ActivityStateInput from './views/ActivityState/Input.vue';
import ActivityStateDetail from './views/ActivityState/Detail.vue';

import ApprovalConfigurationIndex from './views/ApprovalConfiguration/Index.vue';
import ApprovalConfigurationInput from './views/ApprovalConfiguration/Input.vue';
import ApprovalConfigurationDetail from './views/ApprovalConfiguration/Detail.vue';
import ApprovalConfigurationIndexDetail from './views/ApprovalConfiguration/IndexDetail.vue';
import ApprovalConfigurationContent from './views/ApprovalConfiguration/ApprovalConfigurationContent.vue';

import AppliedToIndex from './views/AppliedTo/Index.vue';
import AppliedToInput from './views/AppliedTo/Input.vue';
import AppliedToDetail from './views/AppliedTo/Detail.vue';

import ApprovalTypeIndex from './views/ApprovalType/Index.vue';
import ApprovalTypeInput from './views/ApprovalType/Input.vue';
import ApprovalTypeDetail from './views/ApprovalType/Detail.vue';

import ApprovalInstanceIndex from './views/ApprovalInstance/Index.vue';
import ApprovalInstanceInput from './views/ApprovalInstance/Input.vue';
import ApprovalInstanceDetail from './views/ApprovalInstance/Detail.vue';
import ApprovalInstanceIndexDetail from './views/ApprovalInstance/IndexDetail.vue';

import ApprovalConfigurationInstanceIndex from './views/ApprovalConfigurationInstance/Index.vue';
import ApprovalConfigurationInstanceInput from './views/ApprovalConfigurationInstance/Input.vue';
import ApprovalConfigurationInstanceDetail from './views/ApprovalConfigurationInstance/Detail.vue';
import ApprovalConfigurationInstanceIndexDetail from './views/ApprovalConfigurationInstance/IndexDetail.vue';

import DelegationSettingIndex from './views/DelegationSetting/Index.vue';
import DelegationSettingInput from './views/DelegationSetting/Input.vue';
import DelegationSettingDetail from './views/DelegationSetting/Detail.vue';

import ApprovalHistoryIndex from './views/ApprovalHistory/Index.vue';
import ApprovalHistoryInput from './views/ApprovalHistory/Input.vue';
import ApprovalHistoryDetail from './views/ApprovalHistory/Detail.vue';

import StatusIndex from './views/Status/Index.vue';
import StatusInput from './views/Status/Input.vue';
import StatusDetail from './views/Status/Detail.vue';

import UserInfoIndex from './views/UserInfo/Index.vue';
import UserInfoInput from './views/UserInfo/Input.vue';
import UserInfoDetail from './views/UserInfo/Detail.vue';

import PostIndex from './views/Post/Index.vue';
import PostInput from './views/Post/Input.vue';
import PostDetail from './views/Post/Detail.vue';

import BatchCloseWorkOrder from './views/WorkOrderProcess/BatchCloseWorkOrder.vue';

// IMPORT JOBPOSITION START
import JobPositionIndex from './views/JobPosition/Index.vue';
import JobPositionInput from './views/JobPosition/Input.vue';
import JobPositionDetail from './views/JobPosition/Detail.vue';
// IMPORT JOBPOSITION END

// IMPORT VENDOR START
import VendorIndex from './views/Vendor/Index.vue';
import VendorInput from './views/Vendor/Input.vue';
import VendorDetail from './views/Vendor/Detail.vue';


// IMPORT VENDOR END

// IMPORT VENDORTYPE START
import VendorTypeIndex from './views/VendorType/Index.vue';
import VendorTypeInput from './views/VendorType/Input.vue';
import VendorTypeDetail from './views/VendorType/Detail.vue';


// IMPORT VENDORTYPE END

// IMPORT UOM START
import UomIndex from './views/Uom/Index.vue';
import UomInput from './views/Uom/Input.vue';
import UomDetail from './views/Uom/Detail.vue';


// IMPORT UOM END

// IMPORT PACKAGINGTYPE START
import PackagingTypeIndex from './views/PackagingType/Index.vue';
import PackagingTypeInput from './views/PackagingType/Input.vue';
import PackagingTypeDetail from './views/PackagingType/Detail.vue';


// IMPORT PACKAGINGTYPE END


// IMPORT PARTCLASSIFICATION START
import PartClassificationIndex from './views/PartClassification/Index.vue';
import PartClassificationInput from './views/PartClassification/Input.vue';
import PartClassificationDetail from './views/PartClassification/Detail.vue';


// IMPORT PARTCLASSIFICATION END


// IMPORT PROCESSTYPE START
import ProcessTypeIndex from './views/ProcessType/Index.vue';
import ProcessTypeInput from './views/ProcessType/Input.vue';
import ProcessTypeDetail from './views/ProcessType/Detail.vue';


// IMPORT PROCESSTYPE END

// IMPORT SUBPROCESS START
import SubprocessIndex from './views/Subprocess/Index.vue';
import SubprocessInput from './views/Subprocess/Input.vue';
import SubprocessDetail from './views/Subprocess/Detail.vue';


// IMPORT SUBPROCESS END

// IMPORT LINE START
import LineIndex from './views/Line/Index.vue';
import LineInput from './views/Line/Input.vue';
import LineDetail from './views/Line/Detail.vue';


// IMPORT LINE END


// IMPORT JIG START
import JigIndex from './views/Jig/Index.vue';
import JigInput from './views/Jig/Input.vue';
import JigDetail from './views/Jig/Detail.vue';


// IMPORT JIG END

// IMPORT DIES START
import DiesIndex from './views/Dies/Index.vue';
import DiesInput from './views/Dies/Input.vue';
import DiesDetail from './views/Dies/Detail.vue';


// IMPORT DIES END


// IMPORT QCVISUALCONFIG START
import QcVisualConfigIndex from './views/QcVisualConfig/Index.vue';
import QcVisualConfigInput from './views/QcVisualConfig/Input.vue';
import QcVisualConfigDetail from './views/QcVisualConfig/Detail.vue';


// IMPORT QCVISUALCONFIG END


// IMPORT STANDARTIMECATEGORY START
import StandarTimeCategoryIndex from './views/StandarTimeCategory/Index.vue';
import StandarTimeCategoryInput from './views/StandarTimeCategory/Input.vue';
import StandarTimeCategoryDetail from './views/StandarTimeCategory/Detail.vue';


// IMPORT STANDARTIMECATEGORY END

// IMPORT PRODUCTIONSTANDARTIME START
import ProductionStandarTimeIndex from './views/ProductionStandarTime/Index.vue';
import ProductionStandarTimeInput from './views/ProductionStandarTime/Input.vue';
import ProductionStandarTimeDetail from './views/ProductionStandarTime/Detail.vue';


// IMPORT PRODUCTIONSTANDARTIME END


// IMPORT NEXTPROCESS START
import NextProcessIndex from './views/NextProcess/Index.vue';
import NextProcessInput from './views/NextProcess/Input.vue';
import NextProcessDetail from './views/NextProcess/Detail.vue';


// IMPORT NEXTPROCESS END

// IMPORT BILLOFPROCESSPARTTYPE START
import BillOfProcessPartTypeIndex from './views/BillOfProcessPartType/Index.vue';
import BillOfProcessPartTypeInput from './views/BillOfProcessPartType/Input.vue';
import BillOfProcessPartTypeDetail from './views/BillOfProcessPartType/Detail.vue';


// IMPORT BILLOFPROCESSPARTTYPE END


// IMPORT PART START
import PartIndex from './views/Part/Index.vue';
import PartInput from './views/Part/Input.vue';
import PartDetail from './views/Part/Detail.vue';


// IMPORT PART END


// IMPORT PARTPRICE START
import PartPriceIndex from './views/PartPrice/Index.vue';
import PartPriceInput from './views/PartPrice/Input.vue';
import PartPriceDetail from './views/PartPrice/Detail.vue';


// IMPORT PARTPRICE END

// IMPORT BILLOFPROCESS START
import BillOfProcessIndex from './views/BillOfProcess/Index.vue';
import BillOfProcessInput from './views/BillOfProcess/Input.vue';
import BillOfProcessDetail from './views/BillOfProcess/Detail.vue';


// IMPORT BILLOFPROCESS END

// IMPORT BILLOFMATERIAL START
import BillOfMaterialIndex from './views/BillOfMaterial/Index.vue';
import BillOfMaterialInput from './views/BillOfMaterial/Input.vue';
import BillOfMaterialDetail from './views/BillOfMaterial/Detail.vue';


// IMPORT BILLOFMATERIAL END


// IMPORT PURCHASEREQUEST START
import PurchaseRequestIndex from './views/PurchaseRequest/Index.vue';
import PurchaseRequestInput from './views/PurchaseRequest/Input.vue';
import PurchaseRequestDetail from './views/PurchaseRequest/Detail.vue';
import PurchaseRequestInputSubmission from './views/PurchaseRequest/InputSubmission.vue';
import PurchaseRequestInbox from './views/PurchaseRequest/Inbox.vue';


// IMPORT PURCHASEREQUEST END


// IMPORT PURCHASEORDER START
import PurchaseOrderIndex from './views/PurchaseOrder/Index.vue';
import PurchaseOrderInput from './views/PurchaseOrder/Input.vue';
import PurchaseOrderDetail from './views/PurchaseOrder/Detail.vue';
import PurchaseOrderInputSubmission from './views/PurchaseOrder/InputSubmission.vue';
import PurchaseOrderInbox from './views/PurchaseOrder/Inbox.vue';


// IMPORT PURCHASEORDER END


// IMPORT COMPANYINFO START
import CompanyInfoIndex from './views/CompanyInfo/Index.vue';
import CompanyInfoInput from './views/CompanyInfo/Input.vue';
import CompanyInfoDetail from './views/CompanyInfo/Detail.vue';


// IMPORT COMPANYINFO END

// IMPORT CONTROLCARDTYPE START
import ControlCardTypeIndex from './views/ControlCardType/Index.vue';
import ControlCardTypeInput from './views/ControlCardType/Input.vue';
import ControlCardTypeDetail from './views/ControlCardType/Detail.vue';


// IMPORT CONTROLCARDTYPE END


// IMPORT PUTAWAYCATEGORY START
import PutAwayCategoryIndex from './views/PutAwayCategory/Index.vue';
import PutAwayCategoryInput from './views/PutAwayCategory/Input.vue';
import PutAwayCategoryDetail from './views/PutAwayCategory/Detail.vue';


// IMPORT PUTAWAYCATEGORY END


// IMPORT CONTROLCARDSTATUS START
import ControlCardStatusIndex from './views/ControlCardStatus/Index.vue';
import ControlCardStatusInput from './views/ControlCardStatus/Input.vue';
import ControlCardStatusDetail from './views/ControlCardStatus/Detail.vue';


// IMPORT CONTROLCARDSTATUS END


// IMPORT PARTGOODRECEIPT START
import PartGoodReceiptIndex from './views/PartGoodReceipt/Index.vue';
import PartGoodReceiptInput from './views/PartGoodReceipt/Input.vue';
import PartGoodReceiptDetail from './views/PartGoodReceipt/Detail.vue';
import PartGoodReceiptScan from './views/PartGoodReceipt/ScannerInput.vue';


// IMPORT PARTGOODRECEIPT END


// IMPORT PARTPURCHASEQUALITYCONTROLCONFIRMATION START
import PartPurchaseQualityControlConfirmationIndex from './views/PartPurchaseQualityControlConfirmation/Index.vue';
import PartPurchaseQualityControlConfirmationInput from './views/PartPurchaseQualityControlConfirmation/Input.vue';
import PartPurchaseQualityControlConfirmationDetail from './views/PartPurchaseQualityControlConfirmation/Detail.vue';
import PartPurchaseQualityControlConfirmationInputSubmission
    from './views/PartPurchaseQualityControlConfirmation/InputSubmission.vue';
import PartPurchaseQualityControlConfirmationInbox from './views/PartPurchaseQualityControlConfirmation/Inbox.vue';


// IMPORT PARTPURCHASEQUALITYCONTROLCONFIRMATION END


// IMPORT PUTAWAY START
import PutAwayIndex from './views/PutAway/Index.vue';
import PutAwayInput from './views/PutAway/Input.vue';
import PutAwayDetail from './views/PutAway/Detail.vue';
import PutAwayScan from './views/PutAway/ScannerInput.vue';


// IMPORT PUTAWAY END


// IMPORT DOCUMENTSTATUS START
import DocumentStatusIndex from './views/DocumentStatus/Index.vue';
import DocumentStatusInput from './views/DocumentStatus/Input.vue';
import DocumentStatusDetail from './views/DocumentStatus/Detail.vue';


// IMPORT DOCUMENTSTATUS END


// IMPORT WORKORDERSUPPLY START
import WorkOrderSupplyIndex from './views/WorkOrderSupply/Index.vue';
import WorkOrderSupplyInput from './views/WorkOrderSupply/Input.vue';
import WorkOrderSupplyDetail from './views/WorkOrderSupply/Detail.vue';


// IMPORT WORKORDERSUPPLY END


// IMPORT ATTACHMENTPARTPURCHASEQUALITYCONTROL START
import AttachmentPartPurchaseQualityControlIndex from './views/AttachmentPartPurchaseQualityControl/Index.vue';
import AttachmentPartPurchaseQualityControlInput from './views/AttachmentPartPurchaseQualityControl/Input.vue';
import AttachmentPartPurchaseQualityControlDetail from './views/AttachmentPartPurchaseQualityControl/Detail.vue';


// IMPORT ATTACHMENTPARTPURCHASEQUALITYCONTROL END


// IMPORT PARTPURCHASEQUALITYCONTROL START
import PartPurchaseQualityControlIndex from './views/PartPurchaseQualityControl/Index.vue';
import PartPurchaseQualityControlInput from './views/PartPurchaseQualityControl/Input.vue';
import PartPurchaseQualityControlDetail from './views/PartPurchaseQualityControl/Detail.vue';
import PartPurchaseQualityControlScan from './views/PartPurchaseQualityControl/ScannerInput.vue';


// IMPORT PARTPURCHASEQUALITYCONTROL END


// IMPORT PROBLEMCATEGORY START
import ProblemCategoryIndex from './views/ProblemCategory/Index.vue';
import ProblemCategoryInput from './views/ProblemCategory/Input.vue';
import ProblemCategoryDetail from './views/ProblemCategory/Detail.vue';


// IMPORT PROBLEMCATEGORY END

// IMPORT SHIFT START
import ShiftIndex from './views/Shift/Index.vue';
import ShiftInput from './views/Shift/Input.vue';
import ShiftDetail from './views/Shift/Detail.vue';


// IMPORT SHIFT END

// IMPORT WORKORDEREXECUTIONNG START
import WorkOrderExecutionNgIndex from './views/WorkOrderExecutionNg/Index.vue';
import WorkOrderExecutionNgInput from './views/WorkOrderExecutionNg/Input.vue';
import WorkOrderExecutionNgDetail from './views/WorkOrderExecutionNg/Detail.vue';


// IMPORT WORKORDEREXECUTIONNG END


// IMPORT POSTINGSUPPLYFORPRODUCTION START
import PostingSupplyForProductionIndex from './views/PostingSupplyForProduction/Index.vue';
import PostingSupplyForProductionInput from './views/PostingSupplyForProduction/Input.vue';
import PostingSupplyForProductionDetail from './views/PostingSupplyForProduction/Detail.vue';
import PostingSupplyForProductionScan from './views/PostingSupplyForProduction/ScannerInput.vue';


// IMPORT POSTINGSUPPLYFORPRODUCTION END

// IMPORT WORKORDERPROCESS START
import WorkOrderProcessIndex from './views/WorkOrderProcess/Index.vue';
import WorkOrderProcessInput from './views/WorkOrderProcess/Input.vue';
import WorkOrderProcessDetail from './views/WorkOrderProcess/Detail.vue';
import WorkOrderProcessInputSubmission from './views/WorkOrderProcess/InputSubmission.vue';
import WorkOrderProcessInbox from './views/WorkOrderProcess/Inbox.vue';


// IMPORT WORKORDERPROCESS END

// IMPORT WORKORDEREXECUTION START
import WorkOrderExecutionIndex from './views/WorkOrderExecution/Index.vue';
import WorkOrderExecutionInput from './views/WorkOrderExecution/Input.vue';
import WorkOrderExecutionDetail from './views/WorkOrderExecution/Detail.vue';
import WorkOrderExecutionScan from './views/WorkOrderExecution/ScannerInput.vue';


// IMPORT WORKORDEREXECUTION END

// IMPORT MACHINE START
import MachineIndex from './views/Machine/Index.vue';
import MachineInput from './views/Machine/Input.vue';
import MachineDetail from './views/Machine/Detail.vue';


// IMPORT MACHINE END


// IMPORT PRODUCTIONQUALITYINSPECTIONVISUAL START
import ProductionQualityInspectionVisualIndex from './views/ProductionQualityInspectionVisual/Index.vue';
import ProductionQualityInspectionVisualInput from './views/ProductionQualityInspectionVisual/Input.vue';
import ProductionQualityInspectionVisualDetail from './views/ProductionQualityInspectionVisual/Detail.vue';


// IMPORT PRODUCTIONQUALITYINSPECTIONVISUAL END


// IMPORT SCANNERERRORLOG START
import ScannerErrorLogIndex from './views/ScannerErrorLog/Index.vue';
import ScannerErrorLogInput from './views/ScannerErrorLog/Input.vue';
import ScannerErrorLogDetail from './views/ScannerErrorLog/Detail.vue';


// IMPORT SCANNERERRORLOG END

// IMPORT PICKINGSUPPLYFORPRODUCTION START
import PickingSupplyForProductionIndex from './views/PickingSupplyForProduction/Index.vue';
import PickingSupplyForProductionInput from './views/PickingSupplyForProduction/Input.vue';
import PickingSupplyForProductionDetail from './views/PickingSupplyForProduction/Detail.vue';
import PickingSupplyForProductionScan from './views/PickingSupplyForProduction/ScannerInput.vue';


// IMPORT PICKINGSUPPLYFORPRODUCTION END


// IMPORT CONTROLCARDLOG START
import ControlCardLogIndex from './views/ControlCardLog/Index.vue';
import ControlCardLogInput from './views/ControlCardLog/Input.vue';
import ControlCardLogDetail from './views/ControlCardLog/Detail.vue';


// IMPORT CONTROLCARDLOG END

// IMPORT PRODUCTIONQUALITYINSPECTIONDIMENSION START
import ProductionQualityInspectionDimensionIndex from './views/ProductionQualityInspectionDimension/Index.vue';
import ProductionQualityInspectionDimensionInput from './views/ProductionQualityInspectionDimension/Input.vue';
import ProductionQualityInspectionDimensionDetail from './views/ProductionQualityInspectionDimension/Detail.vue';
import ProductionQualityInspectionDimensionInputSubmission
    from './views/ProductionQualityInspectionDimension/InputSubmission.vue';
import ProductionQualityInspectionDimensionInbox from './views/ProductionQualityInspectionDimension/Inbox.vue';


// IMPORT PRODUCTIONQUALITYINSPECTIONDIMENSION END


// IMPORT RECEIPTFROMPRODUCTIONCASESOURCE START
import ReceiptFromProductionCaseSourceIndex from './views/ReceiptFromProductionCaseSource/Index.vue';
import ReceiptFromProductionCaseSourceInput from './views/ReceiptFromProductionCaseSource/Input.vue';
import ReceiptFromProductionCaseSourceDetail from './views/ReceiptFromProductionCaseSource/Detail.vue';


// IMPORT RECEIPTFROMPRODUCTIONCASESOURCE END


// IMPORT RECEIPTFROMPRODUCTION START
import ReceiptFromProductionIndex from './views/ReceiptFromProduction/Index.vue';
import ReceiptFromProductionInput from './views/ReceiptFromProduction/Input.vue';
import ReceiptFromProductionDetail from './views/ReceiptFromProduction/Detail.vue';
import ReceiptFromProductionScan from './views/ReceiptFromProduction/ScannerInput.vue';


// IMPORT RECEIPTFROMPRODUCTION END

// IMPORT REPAIR START
import RepairIndex from './views/Repair/Index.vue';
import RepairInput from './views/Repair/Input.vue';
import RepairDetail from './views/Repair/Detail.vue';
import RepairScan from './views/Repair/ScannerInput.vue';


// IMPORT REPAIR END


// IMPORT COMBINECASE START
import CombineCaseIndex from './views/CombineCase/Index.vue';
import CombineCaseInput from './views/CombineCase/Input.vue';
import CombineCaseDetail from './views/CombineCase/Detail.vue';
import CombineCaseScan from './views/CombineCase/ScannerInput.vue';


// IMPORT COMBINECASE END

// IMPORT DELIVERYSTATUS START
import DeliveryStatusIndex from './views/DeliveryStatus/Index.vue';
import DeliveryStatusInput from './views/DeliveryStatus/Input.vue';
import DeliveryStatusDetail from './views/DeliveryStatus/Detail.vue';


// IMPORT DELIVERYSTATUS END


// IMPORT DELIVERYORDERSTATUS START
import DeliveryOrderStatusIndex from './views/DeliveryOrderStatus/Index.vue';
import DeliveryOrderStatusInput from './views/DeliveryOrderStatus/Input.vue';
import DeliveryOrderStatusDetail from './views/DeliveryOrderStatus/Detail.vue';


// IMPORT DELIVERYORDERSTATUS END

// IMPORT DOPROGRESSSTATUS START
import DoProgressStatusIndex from './views/DoProgressStatus/Index.vue';
import DoProgressStatusInput from './views/DoProgressStatus/Input.vue';
import DoProgressStatusDetail from './views/DoProgressStatus/Detail.vue';


// IMPORT DOPROGRESSSTATUS END


// IMPORT DELIVERYORDER START
import DeliveryOrderIndex from './views/DeliveryOrder/Index.vue';
import DeliveryOrderInput from './views/DeliveryOrder/Input.vue';
import DeliveryOrderDetail from './views/DeliveryOrder/Detail.vue';


// IMPORT DELIVERYORDER END

// IMPORT METODEQC START
import MetodeQcIndex from './views/MetodeQc/Index.vue';
import MetodeQcInput from './views/MetodeQc/Input.vue';
import MetodeQcDetail from './views/MetodeQc/Detail.vue';


// IMPORT METODEQC END

// IMPORT FINISHGOODQUALITYINSPECTION START
import FinishGoodQualityInspectionIndex from './views/FinishGoodQualityInspection/Index.vue';
import FinishGoodQualityInspectionInput from './views/FinishGoodQualityInspection/Input.vue';
import FinishGoodQualityInspectionDetail from './views/FinishGoodQualityInspection/Detail.vue';


// IMPORT FINISHGOODQUALITYINSPECTION END


// IMPORT DELIVERYINSTRUCTIONSTATUS START
import DeliveryInstructionStatusIndex from './views/DeliveryInstructionStatus/Index.vue';
import DeliveryInstructionStatusInput from './views/DeliveryInstructionStatus/Input.vue';
import DeliveryInstructionStatusDetail from './views/DeliveryInstructionStatus/Detail.vue';


// IMPORT DELIVERYINSTRUCTIONSTATUS END

// IMPORT PARTDESTINATION START
import PartDestinationIndex from './views/PartDestination/Index.vue';
import PartDestinationInput from './views/PartDestination/Input.vue';
import PartDestinationDetail from './views/PartDestination/Detail.vue';


// IMPORT PARTDESTINATION END


// IMPORT CUSTOMER START
import CustomerIndex from './views/Customer/Index.vue';
import CustomerInput from './views/Customer/Input.vue';
import CustomerDetail from './views/Customer/Detail.vue';


// IMPORT CUSTOMER END

// IMPORT PICKINGSTATUS START
import PickingStatusIndex from './views/PickingStatus/Index.vue';
import PickingStatusInput from './views/PickingStatus/Input.vue';
import PickingStatusDetail from './views/PickingStatus/Detail.vue';


// IMPORT PICKINGSTATUS END


// IMPORT DELIVERYINSTRUCTIONSUBCONTRACT START
import DeliveryInstructionSubcontractIndex from './views/DeliveryInstructionSubcontract/Index.vue';
import DeliveryInstructionSubcontractInput from './views/DeliveryInstructionSubcontract/Input.vue';
import DeliveryInstructionSubcontractDetail from './views/DeliveryInstructionSubcontract/Detail.vue';


// IMPORT DELIVERYINSTRUCTIONSUBCONTRACT END


// IMPORT PICKINGFORDELIVERY START
import PickingForDeliveryIndex from './views/PickingForDelivery/Index.vue';
import PickingForDeliveryInput from './views/PickingForDelivery/Input.vue';
import PickingForDeliveryDetail from './views/PickingForDelivery/Detail.vue';
import PickingForDeliveryScan from './views/PickingForDelivery/ScannerInput.vue';


// IMPORT PICKINGFORDELIVERY END

// IMPORT REPACKSTATUS START
import RepackStatusIndex from './views/RepackStatus/Index.vue';
import RepackStatusInput from './views/RepackStatus/Input.vue';
import RepackStatusDetail from './views/RepackStatus/Detail.vue';


// IMPORT REPACKSTATUS END

// IMPORT REPACKING START
import RepackingIndex from './views/Repacking/Index.vue';
import RepackingInput from './views/Repacking/Input.vue';
import RepackingDetail from './views/Repacking/Detail.vue';
import RepackingScan from './views/Repacking/ScannerInput.vue';
import RepackingSearchScan from './views/Repacking/ScannerSearch.vue';


// IMPORT REPACKING END


// IMPORT DELIVERYQUALITYINSPECTIONSTATUS START
import DeliveryQualityInspectionStatusIndex from './views/DeliveryQualityInspectionStatus/Index.vue';
import DeliveryQualityInspectionStatusInput from './views/DeliveryQualityInspectionStatus/Input.vue';
import DeliveryQualityInspectionStatusDetail from './views/DeliveryQualityInspectionStatus/Detail.vue';


// IMPORT DELIVERYQUALITYINSPECTIONSTATUS END


// IMPORT DELIVERYINSTRUCTION START
import DeliveryInstructionIndex from './views/DeliveryInstruction/Index.vue';
import DeliveryInstructionInput from './views/DeliveryInstruction/Input.vue';
import DeliveryInstructionDetail from './views/DeliveryInstruction/Detail.vue';


// IMPORT DELIVERYINSTRUCTION END


// IMPORT QCSTATUS START
import QcStatusIndex from './views/QcStatus/Index.vue';
import QcStatusInput from './views/QcStatus/Input.vue';
import QcStatusDetail from './views/QcStatus/Detail.vue';


// IMPORT QCSTATUS END


// IMPORT CONTROLCARD START
import ControlCardIndex from './views/ControlCard/Index.vue';
import ControlCardInput from './views/ControlCard/Input.vue';
import ControlCardDetail from './views/ControlCard/Detail.vue';


// IMPORT CONTROLCARD END


// IMPORT OUTGOINGCHECKSTATUS START
import OutgoingCheckStatusIndex from './views/OutgoingCheckStatus/Index.vue';
import OutgoingCheckStatusInput from './views/OutgoingCheckStatus/Input.vue';
import OutgoingCheckStatusDetail from './views/OutgoingCheckStatus/Detail.vue';


// IMPORT OUTGOINGCHECKSTATUS END


// IMPORT DELIVERYQUALITYINSPECTION START
import DeliveryQualityInspectionIndex from './views/DeliveryQualityInspection/Index.vue';
import DeliveryQualityInspectionInput from './views/DeliveryQualityInspection/Input.vue';
import DeliveryQualityInspectionDetail from './views/DeliveryQualityInspection/Detail.vue';
import DeliveryQualityInspectionScan from './views/DeliveryQualityInspection/ScannerInput.vue';


// IMPORT DELIVERYQUALITYINSPECTION END


// IMPORT OUTGOINGCHECK START
import OutgoingCheckIndex from './views/OutgoingCheck/Index.vue';
import OutgoingCheckInput from './views/OutgoingCheck/Input.vue';
import OutgoingCheckDetail from './views/OutgoingCheck/Detail.vue';
import OutgoingCheckScan from './views/OutgoingCheck/ScannerInput.vue';


// IMPORT OUTGOINGCHECK END

// IMPORT CONTROLCARDFORDELIVERY START
import ControlCardForDeliveryIndex from './views/ControlCardForDelivery/Index.vue';
import ControlCardForDeliveryInput from './views/ControlCardForDelivery/Input.vue';
import ControlCardForDeliveryDetail from './views/ControlCardForDelivery/Detail.vue';


// IMPORT CONTROLCARDFORDELIVERY END


// IMPORT SURATJALANDELIVERY START
import SuratJalanDeliveryIndex from './views/SuratJalanDelivery/Index.vue';
import SuratJalanDeliveryInput from './views/SuratJalanDelivery/Input.vue';
import SuratJalanDeliveryDetail from './views/SuratJalanDelivery/Detail.vue';


// IMPORT SURATJALANDELIVERY END

// IMPORT SURATJALANDELIVERYSUBCON START
import SuratJalanDeliverySubconIndex from './views/SuratJalanDeliverySubcon/Index.vue';
import SuratJalanDeliverySubconInput from './views/SuratJalanDeliverySubcon/Input.vue';
import SuratJalanDeliverySubconDetail from './views/SuratJalanDeliverySubcon/Detail.vue';


// IMPORT SURATJALANDELIVERYSUBCON END


// IMPORT PRODUCTIONCONTROLTIME START
import ProductionControlTimeIndex from './views/ProductionControlTime/Index.vue';
import ProductionControlTimeInput from './views/ProductionControlTime/Input.vue';
import ProductionControlTimeDetail from './views/ProductionControlTime/Detail.vue';


// IMPORT PRODUCTIONCONTROLTIME END


// IMPORT DELIVERYINSTRUCTIONDELIVERYCARD START
import DeliveryInstructionDeliveryCardIndex from './views/DeliveryInstructionDeliveryCard/Index.vue';
import DeliveryInstructionDeliveryCardInput from './views/DeliveryInstructionDeliveryCard/Input.vue';
import DeliveryInstructionDeliveryCardDetail from './views/DeliveryInstructionDeliveryCard/Detail.vue';


// IMPORT DELIVERYINSTRUCTIONDELIVERYCARD END

// IMPORT WOSFORSUBCONTRACTSTATUS START
import WosForSubcontractStatusIndex from './views/WosForSubcontractStatus/Index.vue';
import WosForSubcontractStatusInput from './views/WosForSubcontractStatus/Input.vue';
import WosForSubcontractStatusDetail from './views/WosForSubcontractStatus/Detail.vue';


// IMPORT WOSFORSUBCONTRACTSTATUS END


// IMPORT PARTMAPPINGSUBCONTRACT START
import PartMappingSubcontractIndex from './views/PartMappingSubcontract/Index.vue';
import PartMappingSubcontractInput from './views/PartMappingSubcontract/Input.vue';
import PartMappingSubcontractDetail from './views/PartMappingSubcontract/Detail.vue';


// IMPORT PARTMAPPINGSUBCONTRACT END


// IMPORT WORKORDERSUPPLYSUBCONTRACT START
import WorkOrderSupplySubContractIndex from './views/WorkOrderSupplySubContract/Index.vue';
import WorkOrderSupplySubContractInput from './views/WorkOrderSupplySubContract/Input.vue';
import WorkOrderSupplySubContractDetail from './views/WorkOrderSupplySubContract/Detail.vue';
import WorkOrderSupplySubContractInputSubmission from './views/WorkOrderSupplySubContract/InputSubmission.vue';
import WorkOrderSupplySubContractInbox from './views/WorkOrderSupplySubContract/Inbox.vue';


// IMPORT WORKORDERSUPPLYSUBCONTRACT END


// IMPORT DISUBCONTDELIVERYCARD START
import DiSubcontDeliveryCardIndex from './views/DiSubcontDeliveryCard/Index.vue';
import DiSubcontDeliveryCardInput from './views/DiSubcontDeliveryCard/Input.vue';
import DiSubcontDeliveryCardDetail from './views/DiSubcontDeliveryCard/Detail.vue';


// IMPORT DISUBCONTDELIVERYCARD END


// IMPORT PICKINGSUPPLYFORSUBCONTRACT START
import PickingSupplyForSubcontractIndex from './views/PickingSupplyForSubcontract/Index.vue';
import PickingSupplyForSubcontractInput from './views/PickingSupplyForSubcontract/Input.vue';
import PickingSupplyForSubcontractDetail from './views/PickingSupplyForSubcontract/Detail.vue';
import PickingSupplyForSubcontractScan from './views/PickingSupplyForSubcontract/ScannerInput.vue';


// IMPORT PICKINGSUPPLYFORSUBCONTRACT END

// IMPORT SUBCONTRACTREQUESTDELIVERY START
import SubcontractRequestDeliveryIndex from './views/SubcontractRequestDelivery/Index.vue';
import SubcontractRequestDeliveryInput from './views/SubcontractRequestDelivery/Input.vue';
import SubcontractRequestDeliveryDetail from './views/SubcontractRequestDelivery/Detail.vue';


// IMPORT SUBCONTRACTREQUESTDELIVERY END


// IMPORT STOCKOPNAMESTATUS START
import StockOpnameStatusIndex from './views/StockOpnameStatus/Index.vue';
import StockOpnameStatusInput from './views/StockOpnameStatus/Input.vue';
import StockOpnameStatusDetail from './views/StockOpnameStatus/Detail.vue';


// IMPORT STOCKOPNAMESTATUS END


// IMPORT AREA START
import AreaIndex from './views/Area/Index.vue';
import AreaInput from './views/Area/Input.vue';
import AreaDetail from './views/Area/Detail.vue';


// IMPORT AREA END


// IMPORT SCRAPEXECUTION START
import ScrapExecutionIndex from './views/ScrapExecution/Index.vue';
import ScrapExecutionInput from './views/ScrapExecution/Input.vue';
import ScrapExecutionDetail from './views/ScrapExecution/Detail.vue';


// IMPORT SCRAPEXECUTION END


// IMPORT STOCKOPNAMEPLAN START
import StockOpnamePlanIndex from './views/StockOpnamePlan/Index.vue';
import StockOpnamePlanInput from './views/StockOpnamePlan/Input.vue';
import StockOpnamePlanDetail from './views/StockOpnamePlan/Detail.vue';


// IMPORT STOCKOPNAMEPLAN END

// IMPORT STOCKADJUSTMENTTYPE START
import StockAdjustmentTypeIndex from './views/StockAdjustmentType/Index.vue';
import StockAdjustmentTypeInput from './views/StockAdjustmentType/Input.vue';
import StockAdjustmentTypeDetail from './views/StockAdjustmentType/Detail.vue';


// IMPORT STOCKADJUSTMENTTYPE END


// IMPORT STOCKADJUSTMENT START
import StockAdjustmentIndex from './views/StockAdjustment/Index.vue';
import StockAdjustmentInput from './views/StockAdjustment/Input.vue';
import StockAdjustmentDetail from './views/StockAdjustment/Detail.vue';
import StockAdjustmentInputSubmission from './views/StockAdjustment/InputSubmission.vue';
import StockAdjustmentInbox from './views/StockAdjustment/Inbox.vue';


// IMPORT STOCKADJUSTMENT END

// IMPORT SUBCONTRACTGOODRECEIPT START
import SubcontractGoodReceiptIndex from './views/SubcontractGoodReceipt/Index.vue';
import SubcontractGoodReceiptInput from './views/SubcontractGoodReceipt/Input.vue';
import SubcontractGoodReceiptDetail from './views/SubcontractGoodReceipt/Detail.vue';
import SubcontractGoodReceiptScan from './views/SubcontractGoodReceipt/ScannerInput.vue';


// IMPORT SUBCONTRACTGOODRECEIPT END


// IMPORT STOCKOPNAMERESULT START
import StockOpnameResultIndex from './views/StockOpnameResult/Index.vue';
import StockOpnameResultInput from './views/StockOpnameResult/Input.vue';
import StockOpnameResultDetail from './views/StockOpnameResult/Detail.vue';
import StockOpnameResultInputSubmission from './views/StockOpnameResult/InputSubmission.vue';
import StockOpnameResultInbox from './views/StockOpnameResult/Inbox.vue';


// IMPORT STOCKOPNAMERESULT END

// IMPORT STOCKOPNAME START
import StockOpnameIndex from './views/StockOpname/Index.vue';
import StockOpnameInput from './views/StockOpname/Input.vue';
import StockOpnameDetail from './views/StockOpname/Detail.vue';
import StockOpnameScan from './views/StockOpname/ScannerInput.vue';


// IMPORT STOCKOPNAME END

// IMPORT SURATJALANSUPPLYFORSUBCONTRACT START
import SuratJalanSupplyForSubcontractIndex from './views/SuratJalanSupplyForSubcontract/Index.vue';
import SuratJalanSupplyForSubcontractInput from './views/SuratJalanSupplyForSubcontract/Input.vue';
import SuratJalanSupplyForSubcontractDetail from './views/SuratJalanSupplyForSubcontract/Detail.vue';


// IMPORT SURATJALANSUPPLYFORSUBCONTRACT END





// IMPORT ANDONQC START
import AndonQCDashboard from './views/AndonQC/AndonQCDashboard.vue';


// IMPORT ANDONQC END

// IMPORT ANDONPRODUCTION START
import AndonProductionDashboard from './views/AndonProduction/AndonProductionDashboard.vue';


// IMPORT ANDONPRODUCTION END

// IMPORT DATASOURCE START
import DataSourceIndex from './views/DataSource/Index.vue';
import DataSourceInput from './views/DataSource/Input.vue';
import DataSourceDetail from './views/DataSource/Detail.vue';


// IMPORT DATASOURCE END

// IMPORT ANDONSTOCK START
import AndonStockDashboard from './views/AndonStock/AndonStockDashboard.vue';


// IMPORT ANDONSTOCK END


// IMPORT ANDONDELIVERY START
import AndonDeliveryDashboard from './views/AndonDelivery/AndonDeliveryDashboard.vue';


// IMPORT ANDONDELIVERY END

// IMPORT ANDONWIP START
import AndonWIPDashboard from './views/AndonWIP/AndonWIPDashboard.vue';


// IMPORT ANDONWIP END
// IMPORT MAINTENANCEHISTORY START
import MaintenanceHistoryIndex from './views/MaintenanceHistory/Index.vue';
import MaintenanceHistoryInput from './views/MaintenanceHistory/Input.vue';
import MaintenanceHistoryDetail from './views/MaintenanceHistory/Detail.vue';


// IMPORT MAINTENANCEHISTORY END

// IMPORT USERSIGNATURE START
import UserSignatureIndex from './views/UserSignature/Index.vue';
import UserSignatureInput from './views/UserSignature/Input.vue';
import UserSignatureDetail from './views/UserSignature/Detail.vue';


// IMPORT USERSIGNATURE END

// IMPORT PICTYPE START
import PicTypeIndex from './views/PicType/Index.vue';
import PicTypeInput from './views/PicType/Input.vue';
import PicTypeDetail from './views/PicType/Detail.vue';


// IMPORT PICTYPE END

// IMPORT PRINTERINFORMATION START
import PrinterInformationIndex from './views/PrinterInformation/Index.vue';
import PrinterInformationInput from './views/PrinterInformation/Input.vue';
import PrinterInformationDetail from './views/PrinterInformation/Detail.vue';


// IMPORT PRINTERINFORMATION END

// IMPORT MOBILEDEVICE START
import MobileDeviceIndex from './views/MobileDevice/Index.vue';
import MobileDeviceInput from './views/MobileDevice/Input.vue';
import MobileDeviceDetail from './views/MobileDevice/Detail.vue';


// IMPORT MOBILEDEVICE END

// IMPORT FINISHGOODQUALITYINSPECTINBOX START
import FinishGoodQualityInspectInboxIndex from './views/FinishGoodQualityInspectInbox/Index.vue';
import FinishGoodQualityInspectInboxInput from './views/FinishGoodQualityInspectInbox/Input.vue';
import FinishGoodQualityInspectInboxDetail from './views/FinishGoodQualityInspectInbox/Detail.vue';
import FinishGoodQualityInspectInboxInputSubmission from './views/FinishGoodQualityInspectInbox/InputSubmission.vue';
import FinishGoodQualityInspectInboxInbox from './views/FinishGoodQualityInspectInbox/Inbox.vue';


// IMPORT FINISHGOODQUALITYINSPECTINBOX END

// IMPORT RACK START
import RackIndex from './views/Rack/Index.vue';
import RackInput from './views/Rack/Input.vue';
import RackDetail from './views/Rack/Detail.vue';


// IMPORT RACK END


// IMPORT REPORTREKAPDELIVERY START
import ReportRekapDeliveryIndex from './views/ReportRekapDelivery/Index.vue';


// IMPORT REPORTREKAPDELIVERY END

// IMPORT REPORTPOSALES START
import ReportPoSalesIndex from './views/ReportPoSales/Index.vue';


// IMPORT REPORTPOSALES END

// IMPORT REPORTPOPEMBELIAN START
import ReportPoPembelianIndex from './views/ReportPoPembelian/Index.vue';


// IMPORT REPORTPOPEMBELIAN END

// IMPORT REPORTTRACINGABILITY START
import ReportTracingAbilityIndex from './views/ReportTracingAbility/Index.vue';


// IMPORT REPORTTRACINGABILITY END

// IMPORT REPORTSTOCKCARD START
import ReportStockCardIndex from './views/ReportStockCard/Index.vue';


// IMPORT REPORTSTOCKCARD END


// IMPORT REPORTDAILYPRODUCTION START
import ReportDailyProductionIndex from './views/ReportDailyProduction/Index.vue';


// IMPORT REPORTDAILYPRODUCTION END

// IMPORT REPORTMTTR START
import ReportMTTRIndex from './views/ReportMTTR/Index.vue';


// IMPORT REPORTMTTR END

// IMPORT REPORTMTBF START
import ReportMTBFIndex from './views/ReportMTBF/Index.vue';


// IMPORT REPORTMTBF END

// IMPORT REPORTSUMMARYNG START
import ReportSummaryNGIndex from './views/ReportSummaryNG/Index.vue';


// IMPORT REPORTSUMMARYNG END

// IMPORT REPORTNG START
import ReportNgIndex from './views/ReportNg/Index.vue';

// IMPORT REPORTNG END


// IMPORT REPORTSUMMARYNG END

// IMPORT REPORTNG END

// IMPORT REPORTINCOMING START
import ReportIncomingIndex from './views/ReportIncoming/Index.vue';


// IMPORT REPORTINCOMING END

// IMPORT LOOKUP START
import LookupIndex from './views/Lookup/Index.vue';
import LookupInput from './views/Lookup/Input.vue';
import LookupDetail from './views/Lookup/Detail.vue';


// IMPORT LOOKUP END

// IMPORT AUDITLOGIN START
import AuditLoginIndex from './views/AuditLogin/Index.vue';
// import AuditLoginInput from './views/AuditLogin/Input.vue';
import AuditLoginDetail from './views/AuditLogin/Detail.vue';


// IMPORT AUDITLOGIN END

// IMPORT VENDORSCRAP START
import VendorScrapIndex from './views/VendorScrap/Index.vue';
import VendorScrapInput from './views/VendorScrap/Input.vue';
import VendorScrapDetail from './views/VendorScrap/Detail.vue';


// IMPORT VENDORSCRAP END

// IMPORT MAPPINGANDONPRODUCTION START
import MappingAndonProductionIndex from './views/MappingAndonProduction/Index.vue';
import MappingAndonProductionInput from './views/MappingAndonProduction/Input.vue';
import MappingAndonProductionDetail from './views/MappingAndonProduction/Detail.vue';


// IMPORT MAPPINGANDONPRODUCTION END



// IMPORT BERITAACARASTOCKOPNAME START
import BeritaAcaraStockOpnameIndex from './views/BeritaAcaraStockOpname/Index.vue';
import BeritaAcaraStockOpnameInput from './views/BeritaAcaraStockOpname/Input.vue';
import BeritaAcaraStockOpnameDetail from './views/BeritaAcaraStockOpname/Detail.vue';


// IMPORT BERITAACARASTOCKOPNAME END


// IMPORT PUTAWAYCONFIGURATION START
import PutawayConfigurationIndex from './views/PutawayConfiguration/Index.vue';
import PutawayConfigurationInput from './views/PutawayConfiguration/Input.vue';
import PutawayConfigurationDetail from './views/PutawayConfiguration/Detail.vue';


// IMPORT PUTAWAYCONFIGURATION END

// IMPORT REPORTTRACINGABILITYBACKWARD START
import ReportTracingAbilityBackwardIndex from './views/ReportTracingAbilityBackward/Index.vue';


// IMPORT REPORTTRACINGABILITYBACKWARD END

// IMPORT REPORTTRACINGABILITYDETAIL START
import ReportTracingAbilityDetailIndex from './views/ReportTracingAbilityDetail/Index.vue';


// IMPORT REPORTTRACINGABILITYDETAIL END

// IMPORT REPORTDELAYDELIVERYINSTRUCTION START
import ReportDelayDeliveryInstructionIndex from './views/ReportDelayDeliveryInstruction/Index.vue';


// IMPORT REPORTDELAYDELIVERYINSTRUCTION END


// IMPORT PUTAWAYHEADER START
import PutawayHeaderIndex from './views/PutawayHeader/Index.vue';
import PutawayHeaderInput from './views/PutawayHeader/Input.vue';
import PutawayHeaderDetail from './views/PutawayHeader/Detail.vue';
import PutawayHeaderScan from './views/PutawayHeader/ScannerInput.vue';


// IMPORT PUTAWAYHEADER END


// IMPORT FINISHGOODQCCONFIRMATION START
import FinishGoodQcConfirmationIndex from './views/FinishGoodQcConfirmation/Index.vue';
import FinishGoodQcConfirmationInput from './views/FinishGoodQcConfirmation/Input.vue';
import FinishGoodQcConfirmationDetail from './views/FinishGoodQcConfirmation/Detail.vue';
import FinishGoodQcConfirmationInputSubmission from './views/FinishGoodQcConfirmation/InputSubmission.vue';
import FinishGoodQcConfirmationInbox from './views/FinishGoodQcConfirmation/Inbox.vue';


// IMPORT FINISHGOODQCCONFIRMATION END

// IMPORT WORKORDEREXECUTIONHOLDTIME START
import WorkOrderExecutionHoldTimeIndex from './views/WorkOrderExecutionHoldTime/Index.vue';
import WorkOrderExecutionHoldTimeInput from './views/WorkOrderExecutionHoldTime/Input.vue';
import WorkOrderExecutionHoldTimeDetail from './views/WorkOrderExecutionHoldTime/Detail.vue';


// IMPORT WORKORDEREXECUTIONHOLDTIME END
//IMPORTROUTE

import PlaygroundIndex from './views/Playgrounds/Index.vue';
import PlaygroundPopUpModal from './views/Playgrounds/popUpModal.vue';

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
// console.log('ina' + store.getters.isLoggedIn);
    if (!store.getters.isLoggedIn) {
        next();
        return;
    }
    next("/");
}

const authGuard = (to, from, next) => {
// console.log('authguard' + store.getters.isLoggedIn);
    next();
    /*if(store.getters.isLoggedIn) {
next();
return;
}
next("/login");*/
}

const baseUrl = process.env.VUE_APP_BASE_FOLDER;
export default new Router({
        base: baseUrl,
        mode: 'history',
        routes: [
            {
                path: "/playground",
                name: "playground",
                component: PlaygroundIndex,
                children: [
                    {
                        path: "/playground/popupmodal/:type",
                        name: "playgroundpopupmodal",
                        component: PlaygroundPopUpModal,
                    },
                ]
            },
            {
                path: "/login",
                name: "login",
                component: LoginIndex,
                beforeEnter: ifNotAuthenticated,
            },
            {
                path: "/",
                name: "home",
                component: Home,
                beforeEnter: authGuard,
            },
            {
                path: "/home",
                name: "homeindex",
                component: Home,
                beforeEnter: authGuard,
            },
            {
                path: "/mobile",
                name: "homemobile",
                component: Mobile,
                beforeEnter: authGuard,
            },
            {
                path: "/inbox",
                name: "inboxindex",
                component: InboxIndex,
                beforeEnter: authGuard,
                children: []
            },

            {
                path: "/moduleinfo",
                name: "moduleinfoindex",
                component: ModuleInfoIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/moduleinfo/create",
                        name: "moduleinfocreate",
                        component: ModuleInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/moduleinfo/create/:id/copydata/:copydata",
                        name: "moduleinfocopydata",
                        component: ModuleInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/moduleinfo/edit/:id",
                        name: "moduleinfoedit",
                        component: ModuleInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/moduleinfo/detail/:id",
                        name: "moduleinfodetail",
                        component: ModuleInfoDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/jobconfiguration",
                name: "jobconfigurationindex",
                component: JobConfigurationIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/jobconfiguration/create",
                        name: "jobconfigurationcreate",
                        component: JobConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobconfiguration/create/:id/copydata/:copydata",
                        name: "jobconfigurationcopydata",
                        component: JobConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobconfiguration/edit/:id",
                        name: "jobconfigurationedit",
                        component: JobConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobconfiguration/detail/:id",
                        name: "jobconfigurationdetail",
                        component: JobConfigurationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/schedulerconfiguration",
                name: "schedulerconfigurationindex",
                component: SchedulerConfigurationIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/schedulerconfiguration/create",
                        name: "schedulerconfigurationcreate",
                        component: SchedulerConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/schedulerconfiguration/create/:id/copydata/:copydata",
                        name: "schedulerconfigurationcopydata",
                        component: SchedulerConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/schedulerconfiguration/edit/:id",
                        name: "schedulerconfigurationedit",
                        component: SchedulerConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/schedulerconfiguration/detail/:id",
                        name: "schedulerconfigurationdetail",
                        component: SchedulerConfigurationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/role",
                name: "roleindex",
                component: RoleIndex,// if you need change to RoleIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/role/create",
                        name: "rolecreate",
                        component: RoleInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/role/create/:id/copydata/:copydata",
                        name: "rolecopydata",
                        component: RoleInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/role/edit/:id",
                        name: "roleedit",
                        component: RoleInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/role/detail/:id",
                        name: "roledetail",
                        component: RoleDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/downloadprocess",
                name: "downloadprocessindex",
                component: DownloadProcessIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/downloadprocess/create",
                        name: "downloadprocesscreate",
                        component: DownloadProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/downloadprocess/create/:id/copydata/:copydata",
                        name: "downloadprocesscopydata",
                        component: DownloadProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/downloadprocess/edit/:id",
                        name: "downloadprocessedit",
                        component: DownloadProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/downloadprocess/detail/:id",
                        name: "downloadprocessdetail",
                        component: DownloadProcessDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/rolemanagement",
                name: "rolemanagementindex",
                component: RoleManagementIndex,// if you need change to RoleManagementIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/rolemanagement/create",
                        name: "rolemanagementcreate",
                        component: RoleManagementInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rolemanagement/create/:id/copydata/:copydata",
                        name: "rolemanagementcopydata",
                        component: RoleManagementInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rolemanagement/edit/:id",
                        name: "rolemanagementedit",
                        component: RoleManagementInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rolemanagement/detail/:id",
                        name: "rolemanagementdetail",
                        component: RoleManagementDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/functioninfo",
                name: "functioninfoindex",
                component: FunctionInfoIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/functioninfo/create",
                        name: "functioninfocreate",
                        component: FunctionInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/functioninfo/create/:id/copydata/:copydata",
                        name: "functioninfocopydata",
                        component: FunctionInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/functioninfo/edit/:id",
                        name: "functioninfoedit",
                        component: FunctionInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/functioninfo/detail/:id",
                        name: "functioninfodetail",
                        component: FunctionInfoDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalgroup",
                name: "approvalgroupindex",
                component: ApprovalGroupIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalgroup/create",
                        name: "approvalgroupcreate",
                        component: ApprovalGroupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalgroup/create/:id/copydata/:copydata",
                        name: "approvalgroupcopydata",
                        component: ApprovalGroupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalgroup/edit/:id",
                        name: "approvalgroupedit",
                        component: ApprovalGroupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalgroup/detail/:id",
                        name: "approvalgroupdetail",
                        component: ApprovalGroupDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalstate",
                name: "approvalstateindex",
                component: ApprovalStateIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalstate/create",
                        name: "approvalstatecreate",
                        component: ApprovalStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstate/create/:id/copydata/:copydata",
                        name: "approvalstatecopydata",
                        component: ApprovalStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstate/edit/:id",
                        name: "approvalstateedit",
                        component: ApprovalStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstate/detail/:id",
                        name: "approvalstatedetail",
                        component: ApprovalStateDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvertype",
                name: "approvertypeindex",
                component: ApproverTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvertype/create",
                        name: "approvertypecreate",
                        component: ApproverTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvertype/create/:id/copydata/:copydata",
                        name: "approvertypecopydata",
                        component: ApproverTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvertype/edit/:id",
                        name: "approvertypeedit",
                        component: ApproverTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvertype/detail/:id",
                        name: "approvertypedetail",
                        component: ApproverTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalstructure",
                name: "approvalstructureindex",
                component: ApprovalStructureIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalstructure/create",
                        name: "approvalstructurecreate",
                        component: ApprovalStructureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstructure/create/:id/copydata/:copydata",
                        name: "approvalstructurecopydata",
                        component: ApprovalStructureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstructure/edit/:id",
                        name: "approvalstructureedit",
                        component: ApprovalStructureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalstructure/detail/:id",
                        name: "approvalstructuredetail",
                        component: ApprovalStructureDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/activitystate",
                name: "activitystateindex",
                component: ActivityStateIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/activitystate/create",
                        name: "activitystatecreate",
                        component: ActivityStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/activitystate/create/:id/copydata/:copydata",
                        name: "activitystatecopydata",
                        component: ActivityStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/activitystate/edit/:id",
                        name: "activitystateedit",
                        component: ActivityStateInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/activitystate/detail/:id",
                        name: "activitystatedetail",
                        component: ActivityStateDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalconfiguration",
                name: "approvalconfigurationindex",
                component: ApprovalConfigurationIndex,// if you need change to ApprovalConfigurationIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalconfiguration/create",
                        name: "approvalconfigurationcreate",
                        component: ApprovalConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfiguration/create/:id/copydata/:copydata",
                        name: "approvalconfigurationcopydata",
                        component: ApprovalConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfiguration/edit/:id",
                        name: "approvalconfigurationedit",
                        component: ApprovalConfigurationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfiguration/detail/:id",
                        name: "approvalconfigurationdetail",
                        component: ApprovalConfigurationDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfiguration/ConfigurationContent/:id",
                        name: "approvalConfigurationContent",
                        component: ApprovalConfigurationContent,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/appliedto",
                name: "appliedtoindex",
                component: AppliedToIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/appliedto/create",
                        name: "appliedtocreate",
                        component: AppliedToInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/appliedto/create/:id/copydata/:copydata",
                        name: "appliedtocopydata",
                        component: AppliedToInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/appliedto/edit/:id",
                        name: "appliedtoedit",
                        component: AppliedToInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/appliedto/detail/:id",
                        name: "appliedtodetail",
                        component: AppliedToDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvaltype",
                name: "approvaltypeindex",
                component: ApprovalTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvaltype/create",
                        name: "approvaltypecreate",
                        component: ApprovalTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvaltype/create/:id/copydata/:copydata",
                        name: "approvaltypecopydata",
                        component: ApprovalTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvaltype/edit/:id",
                        name: "approvaltypeedit",
                        component: ApprovalTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvaltype/detail/:id",
                        name: "approvaltypedetail",
                        component: ApprovalTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalinstance",
                name: "approvalinstanceindex",
                component: ApprovalInstanceIndex,// if you need change to ApprovalInstanceIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalinstance/create",
                        name: "approvalinstancecreate",
                        component: ApprovalInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalinstance/create/:id/copydata/:copydata",
                        name: "approvalinstancecopydata",
                        component: ApprovalInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalinstance/edit/:id",
                        name: "approvalinstanceedit",
                        component: ApprovalInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalinstance/detail/:id",
                        name: "approvalinstancedetail",
                        component: ApprovalInstanceDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalconfigurationinstance",
                name: "approvalconfigurationinstanceindex",
                component: ApprovalConfigurationInstanceIndex,// if you need change to ApprovalConfigurationInstanceIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalconfigurationinstance/create",
                        name: "approvalconfigurationinstancecreate",
                        component: ApprovalConfigurationInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfigurationinstance/create/:id/copydata/:copydata",
                        name: "approvalconfigurationinstancecopydata",
                        component: ApprovalConfigurationInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfigurationinstance/edit/:id",
                        name: "approvalconfigurationinstanceedit",
                        component: ApprovalConfigurationInstanceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalconfigurationinstance/detail/:id",
                        name: "approvalconfigurationinstancedetail",
                        component: ApprovalConfigurationInstanceDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/delegationsetting",
                name: "delegationsettingindex",
                component: DelegationSettingIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/delegationsetting/create",
                        name: "delegationsettingcreate",
                        component: DelegationSettingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/delegationsetting/create/:id/copydata/:copydata",
                        name: "delegationsettingcopydata",
                        component: DelegationSettingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/delegationsetting/edit/:id",
                        name: "delegationsettingedit",
                        component: DelegationSettingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/delegationsetting/detail/:id",
                        name: "delegationsettingdetail",
                        component: DelegationSettingDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/approvalhistory",
                name: "approvalhistoryindex",
                component: ApprovalHistoryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/approvalhistory/create",
                        name: "approvalhistorycreate",
                        component: ApprovalHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalhistory/create/:id/copydata/:copydata",
                        name: "approvalhistorycopydata",
                        component: ApprovalHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalhistory/edit/:id",
                        name: "approvalhistoryedit",
                        component: ApprovalHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/approvalhistory/detail/:id",
                        name: "approvalhistorydetail",
                        component: ApprovalHistoryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/status",
                name: "statusindex",
                component: StatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/status/create",
                        name: "statuscreate",
                        component: StatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/status/create/:id/copydata/:copydata",
                        name: "statuscopydata",
                        component: StatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/status/edit/:id",
                        name: "statusedit",
                        component: StatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/status/detail/:id",
                        name: "statusdetail",
                        component: StatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: "/userinfo",
                name: "userinfoindex",
                component: UserInfoIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/userinfo/create",
                        name: "userinfocreate",
                        component: UserInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/userinfo/create/:id/copydata/:copydata",
                        name: "userinfocopydata",
                        component: UserInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/userinfo/edit/:id",
                        name: "userinfoedit",
                        component: UserInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/userinfo/detail/:id",
                        name: "userinfodetail",
                        component: UserInfoDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            {
                path: '/myprofile',
                name: 'myprofile',
                component: UserInfoDetail,
                beforeEnter: authGuard,
            },

            {
                path: "/post",
                name: "postindex",
                component: PostIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/post/create",
                        name: "postcreate",
                        component: PostInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/post/create/:id/copydata/:copydata",
                        name: "postcopydata",
                        component: PostInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/post/edit/:id",
                        name: "postedit",
                        component: PostInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/post/detail/:id",
                        name: "postdetail",
                        component: PostDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE JOBPOSITION START
            {
                path: "/jobposition",
                name: "jobpositionindex",
                component: JobPositionIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/jobposition/create",
                        name: "jobpositioncreate",
                        component: JobPositionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobposition/create/:id/copydata/:copydata",
                        name: "jobpositioncopydata",
                        component: JobPositionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobposition/edit/:id",
                        name: "jobpositionedit",
                        component: JobPositionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jobposition/detail/:id",
                        name: "jobpositiondetail",
                        component: JobPositionDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE JOBPOSITION END


            // ROUTE VENDOR START
            {
                path: "/vendor",
                name: "vendorindex",
                component: VendorIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/vendor/create",
                        name: "vendorcreate",
                        component: VendorInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendor/create/:id/copydata/:copydata",
                        name: "vendorcopydata",
                        component: VendorInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendor/edit/:id",
                        name: "vendoredit",
                        component: VendorInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendor/detail/:id",
                        name: "vendordetail",
                        component: VendorDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE VENDOR END

            // ROUTE VENDORTYPE START
            {
                path: "/vendortype",
                name: "vendortypeindex",
                component: VendorTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/vendortype/create",
                        name: "vendortypecreate",
                        component: VendorTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendortype/create/:id/copydata/:copydata",
                        name: "vendortypecopydata",
                        component: VendorTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendortype/edit/:id",
                        name: "vendortypeedit",
                        component: VendorTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/vendortype/detail/:id",
                        name: "vendortypedetail",
                        component: VendorTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE VENDORTYPE END

            // ROUTE UOM START
            {
                path: "/uom",
                name: "uomindex",
                component: UomIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/uom/create",
                        name: "uomcreate",
                        component: UomInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/uom/create/:id/copydata/:copydata",
                        name: "uomcopydata",
                        component: UomInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/uom/edit/:id",
                        name: "uomedit",
                        component: UomInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/uom/detail/:id",
                        name: "uomdetail",
                        component: UomDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE UOM END

            // ROUTE PACKAGINGTYPE START
            {
                path: "/packagingtype",
                name: "packagingtypeindex",
                component: PackagingTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/packagingtype/create",
                        name: "packagingtypecreate",
                        component: PackagingTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/packagingtype/create/:id/copydata/:copydata",
                        name: "packagingtypecopydata",
                        component: PackagingTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/packagingtype/edit/:id",
                        name: "packagingtypeedit",
                        component: PackagingTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/packagingtype/detail/:id",
                        name: "packagingtypedetail",
                        component: PackagingTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PACKAGINGTYPE END


            // ROUTE PARTCLASSIFICATION START
            {
                path: "/partclassification",
                name: "partclassificationindex",
                component: PartClassificationIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partclassification/create",
                        name: "partclassificationcreate",
                        component: PartClassificationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partclassification/create/:id/copydata/:copydata",
                        name: "partclassificationcopydata",
                        component: PartClassificationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partclassification/edit/:id",
                        name: "partclassificationedit",
                        component: PartClassificationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partclassification/detail/:id",
                        name: "partclassificationdetail",
                        component: PartClassificationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTCLASSIFICATION END


            // ROUTE PROCESSTYPE START
            {
                path: "/processtype",
                name: "processtypeindex",
                component: ProcessTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/processtype/create",
                        name: "processtypecreate",
                        component: ProcessTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/processtype/create/:id/copydata/:copydata",
                        name: "processtypecopydata",
                        component: ProcessTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/processtype/edit/:id",
                        name: "processtypeedit",
                        component: ProcessTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/processtype/detail/:id",
                        name: "processtypedetail",
                        component: ProcessTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PROCESSTYPE END

            // ROUTE SUBPROCESS START
            {
                path: "/subprocess",
                name: "subprocessindex",
                component: SubprocessIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/subprocess/create",
                        name: "subprocesscreate",
                        component: SubprocessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subprocess/create/:id/copydata/:copydata",
                        name: "subprocesscopydata",
                        component: SubprocessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subprocess/edit/:id",
                        name: "subprocessedit",
                        component: SubprocessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subprocess/detail/:id",
                        name: "subprocessdetail",
                        component: SubprocessDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SUBPROCESS END

            // ROUTE LINE START
            {
                path: "/line",
                name: "lineindex",
                component: LineIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/line/create",
                        name: "linecreate",
                        component: LineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/line/create/:id/copydata/:copydata",
                        name: "linecopydata",
                        component: LineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/line/edit/:id",
                        name: "lineedit",
                        component: LineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/line/detail/:id",
                        name: "linedetail",
                        component: LineDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE LINE END


            // ROUTE JIG START
            {
                path: "/jig",
                name: "jigindex",
                component: JigIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/jig/create",
                        name: "jigcreate",
                        component: JigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jig/create/:id/copydata/:copydata",
                        name: "jigcopydata",
                        component: JigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jig/edit/:id",
                        name: "jigedit",
                        component: JigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/jig/detail/:id",
                        name: "jigdetail",
                        component: JigDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE JIG END

            // ROUTE DIES START
            {
                path: "/dies",
                name: "diesindex",
                component: DiesIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/dies/create",
                        name: "diescreate",
                        component: DiesInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/dies/create/:id/copydata/:copydata",
                        name: "diescopydata",
                        component: DiesInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/dies/edit/:id",
                        name: "diesedit",
                        component: DiesInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/dies/detail/:id",
                        name: "diesdetail",
                        component: DiesDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DIES END


            // ROUTE QCVISUALCONFIG START
            {
                path: "/qcvisualconfig",
                name: "qcvisualconfigindex",
                component: QcVisualConfigIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/qcvisualconfig/create",
                        name: "qcvisualconfigcreate",
                        component: QcVisualConfigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcvisualconfig/create/:id/copydata/:copydata",
                        name: "qcvisualconfigcopydata",
                        component: QcVisualConfigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcvisualconfig/edit/:id",
                        name: "qcvisualconfigedit",
                        component: QcVisualConfigInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcvisualconfig/detail/:id",
                        name: "qcvisualconfigdetail",
                        component: QcVisualConfigDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE QCVISUALCONFIG END


            // ROUTE STANDARTIMECATEGORY START
            {
                path: "/standartimecategory",
                name: "standartimecategoryindex",
                component: StandarTimeCategoryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/standartimecategory/create",
                        name: "standartimecategorycreate",
                        component: StandarTimeCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/standartimecategory/create/:id/copydata/:copydata",
                        name: "standartimecategorycopydata",
                        component: StandarTimeCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/standartimecategory/edit/:id",
                        name: "standartimecategoryedit",
                        component: StandarTimeCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/standartimecategory/detail/:id",
                        name: "standartimecategorydetail",
                        component: StandarTimeCategoryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE STANDARTIMECATEGORY END

            // ROUTE PRODUCTIONSTANDARTIME START
            {
                path: "/productionstandartime",
                name: "productionstandartimeindex",
                component: ProductionStandarTimeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/productionstandartime/create",
                        name: "productionstandartimecreate",
                        component: ProductionStandarTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionstandartime/create/:id/copydata/:copydata",
                        name: "productionstandartimecopydata",
                        component: ProductionStandarTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionstandartime/edit/:id",
                        name: "productionstandartimeedit",
                        component: ProductionStandarTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionstandartime/detail/:id",
                        name: "productionstandartimedetail",
                        component: ProductionStandarTimeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PRODUCTIONSTANDARTIME END


            // ROUTE NEXTPROCESS START
            {
                path: "/nextprocess",
                name: "nextprocessindex",
                component: NextProcessIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/nextprocess/create",
                        name: "nextprocesscreate",
                        component: NextProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/nextprocess/create/:id/copydata/:copydata",
                        name: "nextprocesscopydata",
                        component: NextProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/nextprocess/edit/:id",
                        name: "nextprocessedit",
                        component: NextProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/nextprocess/detail/:id",
                        name: "nextprocessdetail",
                        component: NextProcessDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE NEXTPROCESS END

            // ROUTE BILLOFPROCESSPARTTYPE START
            {
                path: "/billofprocessparttype",
                name: "billofprocessparttypeindex",
                component: BillOfProcessPartTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/billofprocessparttype/create",
                        name: "billofprocessparttypecreate",
                        component: BillOfProcessPartTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocessparttype/create/:id/copydata/:copydata",
                        name: "billofprocessparttypecopydata",
                        component: BillOfProcessPartTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocessparttype/edit/:id",
                        name: "billofprocessparttypeedit",
                        component: BillOfProcessPartTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocessparttype/detail/:id",
                        name: "billofprocessparttypedetail",
                        component: BillOfProcessPartTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE BILLOFPROCESSPARTTYPE END


            // ROUTE PART START
            {
                path: "/part",
                name: "partindex",
                component: PartIndex,// if you need change to PartIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/part/create",
                        name: "partcreate",
                        component: PartInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/part/create/:id/copydata/:copydata",
                        name: "partcopydata",
                        component: PartInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/part/edit/:id",
                        name: "partedit",
                        component: PartInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/part/detail/:id",
                        name: "partdetail",
                        component: PartDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PART END


            // ROUTE PARTPRICE START
            {
                path: "/partprice",
                name: "partpriceindex",
                component: PartPriceIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partprice/create",
                        name: "partpricecreate",
                        component: PartPriceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partprice/create/:id/copydata/:copydata",
                        name: "partpricecopydata",
                        component: PartPriceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partprice/edit/:id",
                        name: "partpriceedit",
                        component: PartPriceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partprice/detail/:id",
                        name: "partpricedetail",
                        component: PartPriceDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTPRICE END

            // ROUTE BILLOFPROCESS START
            {
                path: "/billofprocess",
                name: "billofprocessindex",
                component: BillOfProcessIndex,// if you need change to BillOfProcessIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/billofprocess/create",
                        name: "billofprocesscreate",
                        component: BillOfProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocess/create/:id/copydata/:copydata",
                        name: "billofprocesscopydata",
                        component: BillOfProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocess/edit/:id",
                        name: "billofprocessedit",
                        component: BillOfProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofprocess/detail/:id",
                        name: "billofprocessdetail",
                        component: BillOfProcessDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE BILLOFPROCESS END

            // ROUTE BILLOFMATERIAL START
            {
                path: "/billofmaterial",
                name: "billofmaterialindex",
                component: BillOfMaterialIndex,// if you need change to BillOfMaterialIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/billofmaterial/create",
                        name: "billofmaterialcreate",
                        component: BillOfMaterialInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofmaterial/create/:id/copydata/:copydata",
                        name: "billofmaterialcopydata",
                        component: BillOfMaterialInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofmaterial/edit/:id",
                        name: "billofmaterialedit",
                        component: BillOfMaterialInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/billofmaterial/detail/:id",
                        name: "billofmaterialdetail",
                        component: BillOfMaterialDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE BILLOFMATERIAL END


            // ROUTE PURCHASEREQUEST START
            {
                path: "/purchaserequest",
                name: "purchaserequestindex",
                component: PurchaseRequestIndex,// if you need change to PurchaseRequestIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/purchaserequest/create",
                        name: "purchaserequestcreate",
                        component: PurchaseRequestInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaserequest/create/:id/copydata/:copydata",
                        name: "purchaserequestcopydata",
                        component: PurchaseRequestInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaserequest/edit/:id",
                        name: "purchaserequestedit",
                        component: PurchaseRequestInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaserequest/detail/:id",
                        name: "purchaserequestdetail",
                        component: PurchaseRequestDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/purchaserequest/inbox",
                name: "purchaserequestinbox",
                component: PurchaseRequestInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/purchaserequest/createinboxrequest/:id",
                        name: "purchaserequestcreateinboxrequest",
                        component: PurchaseRequestInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE PURCHASEREQUEST END


            // ROUTE PURCHASEORDER START
            {
                path: "/purchaseorder",
                name: "purchaseorderindex",
                component: PurchaseOrderIndex,// if you need change to PurchaseOrderIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/purchaseorder/create",
                        name: "purchaseordercreate",
                        component: PurchaseOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaseorder/create/:id/copydata/:copydata",
                        name: "purchaseordercopydata",
                        component: PurchaseOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaseorder/edit/:id",
                        name: "purchaseorderedit",
                        component: PurchaseOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/purchaseorder/detail/:id",
                        name: "purchaseorderdetail",
                        component: PurchaseOrderDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/purchaseorder/inbox",
                name: "purchaseorderinbox",
                component: PurchaseOrderInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/purchaseorder/createinboxrequest/:id",
                        name: "purchaseordercreateinboxrequest",
                        component: PurchaseOrderInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE PURCHASEORDER END


            // ROUTE COMPANYINFO START
            {
                path: "/companyinfo",
                name: "companyinfoindex",
                component: CompanyInfoIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/companyinfo/create",
                        name: "companyinfocreate",
                        component: CompanyInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/companyinfo/create/:id/copydata/:copydata",
                        name: "companyinfocopydata",
                        component: CompanyInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/companyinfo/edit/:id",
                        name: "companyinfoedit",
                        component: CompanyInfoInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/companyinfo/detail/:id",
                        name: "companyinfodetail",
                        component: CompanyInfoDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE COMPANYINFO END

            // ROUTE CONTROLCARDTYPE START
            {
                path: "/controlcardtype",
                name: "controlcardtypeindex",
                component: ControlCardTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcardtype/create",
                        name: "controlcardtypecreate",
                        component: ControlCardTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardtype/create/:id/copydata/:copydata",
                        name: "controlcardtypecopydata",
                        component: ControlCardTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardtype/edit/:id",
                        name: "controlcardtypeedit",
                        component: ControlCardTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardtype/detail/:id",
                        name: "controlcardtypedetail",
                        component: ControlCardTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARDTYPE END


            // ROUTE PUTAWAYCATEGORY START
            {
                path: "/putawaycategory",
                name: "putawaycategoryindex",
                component: PutAwayCategoryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/putawaycategory/create",
                        name: "putawaycategorycreate",
                        component: PutAwayCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putawaycategory/create/:id/copydata/:copydata",
                        name: "putawaycategorycopydata",
                        component: PutAwayCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putawaycategory/edit/:id",
                        name: "putawaycategoryedit",
                        component: PutAwayCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putawaycategory/detail/:id",
                        name: "putawaycategorydetail",
                        component: PutAwayCategoryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PUTAWAYCATEGORY END


            // ROUTE CONTROLCARDSTATUS START
            {
                path: "/controlcardstatus",
                name: "controlcardstatusindex",
                component: ControlCardStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcardstatus/create",
                        name: "controlcardstatuscreate",
                        component: ControlCardStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardstatus/create/:id/copydata/:copydata",
                        name: "controlcardstatuscopydata",
                        component: ControlCardStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardstatus/edit/:id",
                        name: "controlcardstatusedit",
                        component: ControlCardStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardstatus/detail/:id",
                        name: "controlcardstatusdetail",
                        component: ControlCardStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARDSTATUS END


            // ROUTE CONTROLCARDLOG START
            {
                path: "/controlcardlog",
                name: "controlcardlogindex",
                component: ControlCardLogIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcardlog/create",
                        name: "controlcardlogcreate",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/create/:id/copydata/:copydata",
                        name: "controlcardlogcopydata",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/edit/:id",
                        name: "controlcardlogedit",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/detail/:id",
                        name: "controlcardlogdetail",
                        component: ControlCardLogDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARDLOG END

            // ROUTE PUTAWAY START
            {
                path: "/putaway",
                name: "putawayindex",
                component: PutAwayIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/putaway/create",
                        name: "putawaycreate",
                        component: PutAwayInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putaway/create/:id/copydata/:copydata",
                        name: "putawaycopydata",
                        component: PutAwayInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putaway/edit/:id",
                        name: "putawayedit",
                        component: PutAwayInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putaway/detail/:id",
                        name: "putawaydetail",
                        component: PutAwayDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/putaway/scan/:id",
                        name: "putawayscan",
                        component: PutAwayScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PUTAWAY END

            // ROUTE PARTPURCHASEQUALITYCONTROL START
            {
                path: "/partpurchasequalitycontrol",
                name: "partpurchasequalitycontrolindex",
                component: PartPurchaseQualityControlIndex,// if you need change to PartPurchaseQualityControlIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partpurchasequalitycontrol/create",
                        name: "partpurchasequalitycontrolcreate",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/create/:id/copydata/:copydata",
                        name: "partpurchasequalitycontrolcopydata",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/edit/:id",
                        name: "partpurchasequalitycontroledit",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/detail/:id",
                        name: "partpurchasequalitycontroldetail",
                        component: PartPurchaseQualityControlDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/scan/:id",
                        name: "partpurchasequalitycontrolscan",
                        component: PartPurchaseQualityControlScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTPURCHASEQUALITYCONTROL END


            // ROUTE PARTGOODRECEIPT START
            {
                path: "/partgoodreceipt",
                name: "partgoodreceiptindex",
                component: PartGoodReceiptIndex,// if you need change to PartGoodReceiptIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partgoodreceipt/create",
                        name: "partgoodreceiptcreate",
                        component: PartGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partgoodreceipt/create/:id/copydata/:copydata",
                        name: "partgoodreceiptcopydata",
                        component: PartGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partgoodreceipt/edit/:id",
                        name: "partgoodreceiptedit",
                        component: PartGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partgoodreceipt/detail/:id",
                        name: "partgoodreceiptdetail",
                        component: PartGoodReceiptDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partgoodreceipt/scan/:id",
                        name: "partgoodreceiptscan",
                        component: PartGoodReceiptScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTGOODRECEIPT END


            // ROUTE PARTPURCHASEQUALITYCONTROLCONFIRMATION START
            {
                path: "/partpurchasequalitycontrolconfirmation",
                name: "partpurchasequalitycontrolconfirmationindex",
                component: PartPurchaseQualityControlConfirmationIndex,// if you need change to PartPurchaseQualityControlConfirmationIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partpurchasequalitycontrolconfirmation/create",
                        name: "partpurchasequalitycontrolconfirmationcreate",
                        component: PartPurchaseQualityControlConfirmationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrolconfirmation/create/:id/copydata/:copydata",
                        name: "partpurchasequalitycontrolconfirmationcopydata",
                        component: PartPurchaseQualityControlConfirmationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrolconfirmation/edit/:id",
                        name: "partpurchasequalitycontrolconfirmationedit",
                        component: PartPurchaseQualityControlConfirmationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrolconfirmation/detail/:id",
                        name: "partpurchasequalitycontrolconfirmationdetail",
                        component: PartPurchaseQualityControlConfirmationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/partpurchasequalitycontrolconfirmation/inbox",
                name: "partpurchasequalitycontrolconfirmationinbox",
                component: PartPurchaseQualityControlConfirmationInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partpurchasequalitycontrolconfirmation/createinboxrequest/:id",
                        name: "partpurchasequalitycontrolconfirmationcreateinboxrequest",
                        component: PartPurchaseQualityControlConfirmationInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE PARTPURCHASEQUALITYCONTROLCONFIRMATION END

            // ROUTE WORKORDERPROCESS START
            {
                path: "/workorderprocess",
                name: "workorderprocessindex",
                component: WorkOrderProcessIndex,// if you need change to WorkOrderProcessIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workorderprocess/create",
                        name: "workorderprocesscreate",
                        component: WorkOrderProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderprocess/create/:id/copydata/:copydata",
                        name: "workorderprocesscopydata",
                        component: WorkOrderProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderprocess/edit/:id",
                        name: "workorderprocessedit",
                        component: WorkOrderProcessInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderprocess/detail/:id",
                        name: "workorderprocessdetail",
                        component: WorkOrderProcessDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderprocess/batchclose/",
                        name: "batchcloseworkorder",
                        component: BatchCloseWorkOrder,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/workorderprocess/inbox",
                name: "workorderprocessinbox",
                component: WorkOrderProcessInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workorderprocess/createinboxrequest/:id",
                        name: "workorderprocesscreateinboxrequest",
                        component: WorkOrderProcessInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE WORKORDERPROCESS END


            // ROUTE SCANNERERRORLOG START
            {
                path: "/scannererrorlog",
                name: "scannererrorlogindex",
                component: ScannerErrorLogIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/scannererrorlog/create",
                        name: "scannererrorlogcreate",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/create/:id/copydata/:copydata",
                        name: "scannererrorlogcopydata",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/edit/:id",
                        name: "scannererrorlogedit",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/detail/:id",
                        name: "scannererrorlogdetail",
                        component: ScannerErrorLogDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DOCUMENTSTATUS START
            {
                path: "/documentstatus",
                name: "documentstatusindex",
                component: DocumentStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/documentstatus/create",
                        name: "documentstatuscreate",
                        component: DocumentStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/documentstatus/create/:id/copydata/:copydata",
                        name: "documentstatuscopydata",
                        component: DocumentStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/documentstatus/edit/:id",
                        name: "documentstatusedit",
                        component: DocumentStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/documentstatus/detail/:id",
                        name: "documentstatusdetail",
                        component: DocumentStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DOCUMENTSTATUS END


            // ROUTE WORKORDERSUPPLY START
            {
                path: "/workordersupply",
                name: "workordersupplyindex",
                component: WorkOrderSupplyIndex,// if you need change to WorkOrderSupplyIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workordersupply/create",
                        name: "workordersupplycreate",
                        component: WorkOrderSupplyInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupply/create/:id/copydata/:copydata",
                        name: "workordersupplycopydata",
                        component: WorkOrderSupplyInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupply/edit/:id",
                        name: "workordersupplyedit",
                        component: WorkOrderSupplyInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupply/detail/:id",
                        name: "workordersupplydetail",
                        component: WorkOrderSupplyDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE WORKORDERSUPPLY END


            // ROUTE ATTACHMENTPARTPURCHASEQUALITYCONTROL START
            {
                path: "/attachmentpartpurchasequalitycontrol",
                name: "attachmentpartpurchasequalitycontrolindex",
                component: AttachmentPartPurchaseQualityControlIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/attachmentpartpurchasequalitycontrol/create",
                        name: "attachmentpartpurchasequalitycontrolcreate",
                        component: AttachmentPartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/attachmentpartpurchasequalitycontrol/create/:id/copydata/:copydata",
                        name: "attachmentpartpurchasequalitycontrolcopydata",
                        component: AttachmentPartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/attachmentpartpurchasequalitycontrol/edit/:id",
                        name: "attachmentpartpurchasequalitycontroledit",
                        component: AttachmentPartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/attachmentpartpurchasequalitycontrol/detail/:id",
                        name: "attachmentpartpurchasequalitycontroldetail",
                        component: AttachmentPartPurchaseQualityControlDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE ATTACHMENTPARTPURCHASEQUALITYCONTROL END


            // ROUTE PARTPURCHASEQUALITYCONTROL START
            {
                path: "/partpurchasequalitycontrol",
                name: "partpurchasequalitycontrolindex",
                component: PartPurchaseQualityControlIndex,// if you need change to PartPurchaseQualityControlIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partpurchasequalitycontrol/create",
                        name: "partpurchasequalitycontrolcreate",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/create/:id/copydata/:copydata",
                        name: "partpurchasequalitycontrolcopydata",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/edit/:id",
                        name: "partpurchasequalitycontroledit",
                        component: PartPurchaseQualityControlInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/detail/:id",
                        name: "partpurchasequalitycontroldetail",
                        component: PartPurchaseQualityControlDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partpurchasequalitycontrol/scan/:id",
                        name: "partpurchasequalitycontrolscan",
                        component: PartPurchaseQualityControlScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTPURCHASEQUALITYCONTROL END


            // ROUTE PICKINGSUPPLYFORPRODUCTION START
            {
                path: "/pickingsupplyforproduction",
                name: "pickingsupplyforproductionindex",
                component: PickingSupplyForProductionIndex,// if you need change to PickingSupplyForProductionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pickingsupplyforproduction/create",
                        name: "pickingsupplyforproductioncreate",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/create/:id/copydata/:copydata",
                        name: "pickingsupplyforproductioncopydata",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/edit/:id",
                        name: "pickingsupplyforproductionedit",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/detail/:id",
                        name: "pickingsupplyforproductiondetail",
                        component: PickingSupplyForProductionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/scan/:id",
                        name: "pickingsupplyforproductionscan",
                        component: PickingSupplyForProductionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICKINGSUPPLYFORPRODUCTION END

            // ROUTE PROBLEMCATEGORY START
            {
                path: "/problemcategory",
                name: "problemcategoryindex",
                component: ProblemCategoryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/problemcategory/create",
                        name: "problemcategorycreate",
                        component: ProblemCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/problemcategory/create/:id/copydata/:copydata",
                        name: "problemcategorycopydata",
                        component: ProblemCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/problemcategory/edit/:id",
                        name: "problemcategoryedit",
                        component: ProblemCategoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/problemcategory/detail/:id",
                        name: "problemcategorydetail",
                        component: ProblemCategoryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PROBLEMCATEGORY END

            // ROUTE SHIFT START
            {
                path: "/shift",
                name: "shiftindex",
                component: ShiftIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/shift/create",
                        name: "shiftcreate",
                        component: ShiftInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/shift/create/:id/copydata/:copydata",
                        name: "shiftcopydata",
                        component: ShiftInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/shift/edit/:id",
                        name: "shiftedit",
                        component: ShiftInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/shift/detail/:id",
                        name: "shiftdetail",
                        component: ShiftDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SHIFT END

            // ROUTE WORKORDEREXECUTIONNG START
            {
                path: "/workorderexecutionng",
                name: "workorderexecutionngindex",
                component: WorkOrderExecutionNgIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workorderexecutionng/create",
                        name: "workorderexecutionngcreate",
                        component: WorkOrderExecutionNgInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecutionng/create/:id/copydata/:copydata",
                        name: "workorderexecutionngcopydata",
                        component: WorkOrderExecutionNgInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecutionng/edit/:id",
                        name: "workorderexecutionngedit",
                        component: WorkOrderExecutionNgInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecutionng/detail/:id",
                        name: "workorderexecutionngdetail",
                        component: WorkOrderExecutionNgDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE WORKORDEREXECUTIONNG END


            // ROUTE POSTINGSUPPLYFORPRODUCTION START
            {
                path: "/postingsupplyforproduction",
                name: "postingsupplyforproductionindex",
                component: PostingSupplyForProductionIndex,// if you need change to PostingSupplyForProductionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/postingsupplyforproduction/create",
                        name: "postingsupplyforproductioncreate",
                        component: PostingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/postingsupplyforproduction/create/:id/copydata/:copydata",
                        name: "postingsupplyforproductioncopydata",
                        component: PostingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/postingsupplyforproduction/edit/:id",
                        name: "postingsupplyforproductionedit",
                        component: PostingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/postingsupplyforproduction/detail/:id",
                        name: "postingsupplyforproductiondetail",
                        component: PostingSupplyForProductionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/postingsupplyforproduction/scan/:id",
                        name: "postingsupplyforproductionscan",
                        component: PostingSupplyForProductionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE POSTINGSUPPLYFORPRODUCTION END

            // ROUTE WORKORDEREXECUTION START
            {
                path: "/workorderexecution",
                name: "workorderexecutionindex",
                component: WorkOrderExecutionIndex,// if you need change to WorkOrderExecutionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workorderexecution/create",
                        name: "workorderexecutioncreate",
                        component: WorkOrderExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecution/create/:id/copydata/:copydata",
                        name: "workorderexecutioncopydata",
                        component: WorkOrderExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecution/edit/:id",
                        name: "workorderexecutionedit",
                        component: WorkOrderExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecution/detail/:id",
                        name: "workorderexecutiondetail",
                        component: WorkOrderExecutionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workorderexecution/scan/:id",
                        name: "workorderexecutionscan",
                        component: WorkOrderExecutionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE WORKORDEREXECUTION END

            // ROUTE MACHINE START
            {
                path: "/machine",
                name: "machineindex",
                component: MachineIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/machine/create",
                        name: "machinecreate",
                        component: MachineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/machine/create/:id/copydata/:copydata",
                        name: "machinecopydata",
                        component: MachineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/machine/edit/:id",
                        name: "machineedit",
                        component: MachineInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/machine/detail/:id",
                        name: "machinedetail",
                        component: MachineDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE MACHINE END


            // ROUTE PRODUCTIONQUALITYINSPECTIONVISUAL START
            {
                path: "/productionqualityinspectionvisual",
                name: "productionqualityinspectionvisualindex",
                component: ProductionQualityInspectionVisualIndex,// if you need change to ProductionQualityInspectionVisualIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/productionqualityinspectionvisual/create",
                        name: "productionqualityinspectionvisualcreate",
                        component: ProductionQualityInspectionVisualInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectionvisual/create/:id/copydata/:copydata",
                        name: "productionqualityinspectionvisualcopydata",
                        component: ProductionQualityInspectionVisualInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectionvisual/edit/:id",
                        name: "productionqualityinspectionvisualedit",
                        component: ProductionQualityInspectionVisualInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectionvisual/detail/:id",
                        name: "productionqualityinspectionvisualdetail",
                        component: ProductionQualityInspectionVisualDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PRODUCTIONQUALITYINSPECTIONVISUAL END


            // ROUTE SCANNERERRORLOG START
            {
                path: "/scannererrorlog",
                name: "scannererrorlogindex",
                component: ScannerErrorLogIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/scannererrorlog/create",
                        name: "scannererrorlogcreate",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/create/:id/copydata/:copydata",
                        name: "scannererrorlogcopydata",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/edit/:id",
                        name: "scannererrorlogedit",
                        component: ScannerErrorLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scannererrorlog/detail/:id",
                        name: "scannererrorlogdetail",
                        component: ScannerErrorLogDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SCANNERERRORLOG END

            // ROUTE PICKINGSUPPLYFORPRODUCTION START
            {
                path: "/pickingsupplyforproduction",
                name: "pickingsupplyforproductionindex",
                component: PickingSupplyForProductionIndex,// if you need change to PickingSupplyForProductionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pickingsupplyforproduction/create",
                        name: "pickingsupplyforproductioncreate",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/create/:id/copydata/:copydata",
                        name: "pickingsupplyforproductioncopydata",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/edit/:id",
                        name: "pickingsupplyforproductionedit",
                        component: PickingSupplyForProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/detail/:id",
                        name: "pickingsupplyforproductiondetail",
                        component: PickingSupplyForProductionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforproduction/scan/:id",
                        name: "pickingsupplyforproductionscan",
                        component: PickingSupplyForProductionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICKINGSUPPLYFORPRODUCTION END


            // ROUTE CONTROLCARDLOG START
            {
                path: "/controlcardlog",
                name: "controlcardlogindex",
                component: ControlCardLogIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcardlog/create",
                        name: "controlcardlogcreate",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/create/:id/copydata/:copydata",
                        name: "controlcardlogcopydata",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/edit/:id",
                        name: "controlcardlogedit",
                        component: ControlCardLogInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardlog/detail/:id",
                        name: "controlcardlogdetail",
                        component: ControlCardLogDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARDLOG END

            // ROUTE PRODUCTIONQUALITYINSPECTIONDIMENSION START
            {
                path: "/productionqualityinspectiondimension",
                name: "productionqualityinspectiondimensionindex",
                component: ProductionQualityInspectionDimensionIndex,// if you need change to ProductionQualityInspectionDimensionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/productionqualityinspectiondimension/create",
                        name: "productionqualityinspectiondimensioncreate",
                        component: ProductionQualityInspectionDimensionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectiondimension/create/:id/copydata/:copydata",
                        name: "productionqualityinspectiondimensioncopydata",
                        component: ProductionQualityInspectionDimensionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectiondimension/edit/:id",
                        name: "productionqualityinspectiondimensionedit",
                        component: ProductionQualityInspectionDimensionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productionqualityinspectiondimension/detail/:id",
                        name: "productionqualityinspectiondimensiondetail",
                        component: ProductionQualityInspectionDimensionDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/productionqualityinspectiondimension/inbox",
                name: "productionqualityinspectiondimensioninbox",
                component: ProductionQualityInspectionDimensionInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/productionqualityinspectiondimension/createinboxrequest/:id",
                        name: "productionqualityinspectiondimensioncreateinboxrequest",
                        component: ProductionQualityInspectionDimensionInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE PRODUCTIONQUALITYINSPECTIONDIMENSION END


            // ROUTE RECEIPTFROMPRODUCTIONCASESOURCE START
            {
                path: "/receiptfromproductioncasesource",
                name: "receiptfromproductioncasesourceindex",
                component: ReceiptFromProductionCaseSourceIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/receiptfromproductioncasesource/create",
                        name: "receiptfromproductioncasesourcecreate",
                        component: ReceiptFromProductionCaseSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproductioncasesource/create/:id/copydata/:copydata",
                        name: "receiptfromproductioncasesourcecopydata",
                        component: ReceiptFromProductionCaseSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproductioncasesource/edit/:id",
                        name: "receiptfromproductioncasesourceedit",
                        component: ReceiptFromProductionCaseSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproductioncasesource/detail/:id",
                        name: "receiptfromproductioncasesourcedetail",
                        component: ReceiptFromProductionCaseSourceDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE RECEIPTFROMPRODUCTIONCASESOURCE END


            // ROUTE RECEIPTFROMPRODUCTION START
            {
                path: "/receiptfromproduction",
                name: "receiptfromproductionindex",
                component: ReceiptFromProductionIndex,// if you need change to ReceiptFromProductionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/receiptfromproduction/create",
                        name: "receiptfromproductioncreate",
                        component: ReceiptFromProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproduction/create/:id/copydata/:copydata",
                        name: "receiptfromproductioncopydata",
                        component: ReceiptFromProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproduction/edit/:id",
                        name: "receiptfromproductionedit",
                        component: ReceiptFromProductionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproduction/detail/:id",
                        name: "receiptfromproductiondetail",
                        component: ReceiptFromProductionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/receiptfromproduction/scan/:id",
                        name: "receiptfromproductionscan",
                        component: ReceiptFromProductionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE RECEIPTFROMPRODUCTION END

            // ROUTE REPAIR START
            {
                path: "/repair",
                name: "repairindex",
                component: RepairIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/repair/create",
                        name: "repaircreate",
                        component: RepairInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repair/create/:id/copydata/:copydata",
                        name: "repaircopydata",
                        component: RepairInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repair/edit/:id",
                        name: "repairedit",
                        component: RepairInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repair/detail/:id",
                        name: "repairdetail",
                        component: RepairDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repair/scan",
                        name: "repairscan",
                        component: RepairScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE REPAIR END


            // ROUTE COMBINECASE START
            {
                path: "/combinecase",
                name: "combinecaseindex",
                component: CombineCaseIndex,// if you need change to CombineCaseIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/combinecase/create",
                        name: "combinecasecreate",
                        component: CombineCaseInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/combinecase/create/:id/copydata/:copydata",
                        name: "combinecasecopydata",
                        component: CombineCaseInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/combinecase/edit/:id",
                        name: "combinecaseedit",
                        component: CombineCaseInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/combinecase/detail/:id",
                        name: "combinecasedetail",
                        component: CombineCaseDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/combinecase/scan/:id",
                        name: "combinecasescan",
                        component: CombineCaseScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE COMBINECASE END

            // ROUTE DELIVERYSTATUS START
            {
                path: "/deliverystatus",
                name: "deliverystatusindex",
                component: DeliveryStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliverystatus/create",
                        name: "deliverystatuscreate",
                        component: DeliveryStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliverystatus/create/:id/copydata/:copydata",
                        name: "deliverystatuscopydata",
                        component: DeliveryStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliverystatus/edit/:id",
                        name: "deliverystatusedit",
                        component: DeliveryStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliverystatus/detail/:id",
                        name: "deliverystatusdetail",
                        component: DeliveryStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYSTATUS END


            // ROUTE DELIVERYORDERSTATUS START
            {
                path: "/deliveryorderstatus",
                name: "deliveryorderstatusindex",
                component: DeliveryOrderStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryorderstatus/create",
                        name: "deliveryorderstatuscreate",
                        component: DeliveryOrderStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorderstatus/create/:id/copydata/:copydata",
                        name: "deliveryorderstatuscopydata",
                        component: DeliveryOrderStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorderstatus/edit/:id",
                        name: "deliveryorderstatusedit",
                        component: DeliveryOrderStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorderstatus/detail/:id",
                        name: "deliveryorderstatusdetail",
                        component: DeliveryOrderStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYORDERSTATUS END

            // ROUTE DOPROGRESSSTATUS START
            {
                path: "/doprogressstatus",
                name: "doprogressstatusindex",
                component: DoProgressStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/doprogressstatus/create",
                        name: "doprogressstatuscreate",
                        component: DoProgressStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/doprogressstatus/create/:id/copydata/:copydata",
                        name: "doprogressstatuscopydata",
                        component: DoProgressStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/doprogressstatus/edit/:id",
                        name: "doprogressstatusedit",
                        component: DoProgressStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/doprogressstatus/detail/:id",
                        name: "doprogressstatusdetail",
                        component: DoProgressStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DOPROGRESSSTATUS END


            // ROUTE DELIVERYORDER START
            {
                path: "/deliveryorder",
                name: "deliveryorderindex",
                component: DeliveryOrderIndex,// if you need change to DeliveryOrderIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryorder/create",
                        name: "deliveryordercreate",
                        component: DeliveryOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorder/create/:id/copydata/:copydata",
                        name: "deliveryordercopydata",
                        component: DeliveryOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorder/edit/:id",
                        name: "deliveryorderedit",
                        component: DeliveryOrderInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryorder/detail/:id",
                        name: "deliveryorderdetail",
                        component: DeliveryOrderDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYORDER END

            // ROUTE METODEQC START
            {
                path: "/metodeqc",
                name: "metodeqcindex",
                component: MetodeQcIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/metodeqc/create",
                        name: "metodeqccreate",
                        component: MetodeQcInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/metodeqc/create/:id/copydata/:copydata",
                        name: "metodeqccopydata",
                        component: MetodeQcInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/metodeqc/edit/:id",
                        name: "metodeqcedit",
                        component: MetodeQcInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/metodeqc/detail/:id",
                        name: "metodeqcdetail",
                        component: MetodeQcDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE METODEQC END

            // ROUTE FINISHGOODQUALITYINSPECTION START
            {
                path: "/finishgoodqualityinspection",
                name: "finishgoodqualityinspectionindex",
                component: FinishGoodQualityInspectionIndex,// if you need change to FinishGoodQualityInspectionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/finishgoodqualityinspection/create",
                        name: "finishgoodqualityinspectioncreate",
                        component: FinishGoodQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspection/create/:id/copydata/:copydata",
                        name: "finishgoodqualityinspectioncopydata",
                        component: FinishGoodQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspection/edit/:id",
                        name: "finishgoodqualityinspectionedit",
                        component: FinishGoodQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspection/detail/:id",
                        name: "finishgoodqualityinspectiondetail",
                        component: FinishGoodQualityInspectionDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE FINISHGOODQUALITYINSPECTION END


            // ROUTE DELIVERYINSTRUCTIONSTATUS START
            {
                path: "/deliveryinstructionstatus",
                name: "deliveryinstructionstatusindex",
                component: DeliveryInstructionStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryinstructionstatus/create",
                        name: "deliveryinstructionstatuscreate",
                        component: DeliveryInstructionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionstatus/create/:id/copydata/:copydata",
                        name: "deliveryinstructionstatuscopydata",
                        component: DeliveryInstructionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionstatus/edit/:id",
                        name: "deliveryinstructionstatusedit",
                        component: DeliveryInstructionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionstatus/detail/:id",
                        name: "deliveryinstructionstatusdetail",
                        component: DeliveryInstructionStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYINSTRUCTIONSTATUS END

            // ROUTE PARTDESTINATION START
            {
                path: "/partdestination",
                name: "partdestinationindex",
                component: PartDestinationIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partdestination/create",
                        name: "partdestinationcreate",
                        component: PartDestinationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partdestination/create/:id/copydata/:copydata",
                        name: "partdestinationcopydata",
                        component: PartDestinationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partdestination/edit/:id",
                        name: "partdestinationedit",
                        component: PartDestinationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partdestination/detail/:id",
                        name: "partdestinationdetail",
                        component: PartDestinationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTDESTINATION END


            // ROUTE CUSTOMER START
            {
                path: "/customer",
                name: "customerindex",
                component: CustomerIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/customer/create",
                        name: "customercreate",
                        component: CustomerInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/customer/create/:id/copydata/:copydata",
                        name: "customercopydata",
                        component: CustomerInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/customer/edit/:id",
                        name: "customeredit",
                        component: CustomerInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/customer/detail/:id",
                        name: "customerdetail",
                        component: CustomerDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CUSTOMER END

            // ROUTE PICKINGSTATUS START
            {
                path: "/pickingstatus",
                name: "pickingstatusindex",
                component: PickingStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pickingstatus/create",
                        name: "pickingstatuscreate",
                        component: PickingStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingstatus/create/:id/copydata/:copydata",
                        name: "pickingstatuscopydata",
                        component: PickingStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingstatus/edit/:id",
                        name: "pickingstatusedit",
                        component: PickingStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingstatus/detail/:id",
                        name: "pickingstatusdetail",
                        component: PickingStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICKINGSTATUS END


            // ROUTE DELIVERYINSTRUCTIONSUBCONTRACT START
            {
                path: "/deliveryinstructionsubcontract",
                name: "deliveryinstructionsubcontractindex",
                component: DeliveryInstructionSubcontractIndex,// if you need change to DeliveryInstructionSubcontractIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryinstructionsubcontract/create",
                        name: "deliveryinstructionsubcontractcreate",
                        component: DeliveryInstructionSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionsubcontract/create/:id/copydata/:copydata",
                        name: "deliveryinstructionsubcontractcopydata",
                        component: DeliveryInstructionSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionsubcontract/edit/:id",
                        name: "deliveryinstructionsubcontractedit",
                        component: DeliveryInstructionSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructionsubcontract/detail/:id",
                        name: "deliveryinstructionsubcontractdetail",
                        component: DeliveryInstructionSubcontractDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYINSTRUCTIONSUBCONTRACT END


            // ROUTE PICKINGFORDELIVERY START
            {
                path: "/pickingfordelivery",
                name: "pickingfordeliveryindex",
                component: PickingForDeliveryIndex,// if you need change to PickingForDeliveryIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pickingfordelivery/create",
                        name: "pickingfordeliverycreate",
                        component: PickingForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingfordelivery/create/:id/copydata/:copydata",
                        name: "pickingfordeliverycopydata",
                        component: PickingForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingfordelivery/edit/:id",
                        name: "pickingfordeliveryedit",
                        component: PickingForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingfordelivery/detail/:id",
                        name: "pickingfordeliverydetail",
                        component: PickingForDeliveryDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingfordelivery/scan/:id",
                        name: "pickingfordeliveryscan",
                        component: PickingForDeliveryScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICKINGFORDELIVERY END

            // ROUTE REPACKSTATUS START
            {
                path: "/repackstatus",
                name: "repackstatusindex",
                component: RepackStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/repackstatus/create",
                        name: "repackstatuscreate",
                        component: RepackStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repackstatus/create/:id/copydata/:copydata",
                        name: "repackstatuscopydata",
                        component: RepackStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repackstatus/edit/:id",
                        name: "repackstatusedit",
                        component: RepackStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repackstatus/detail/:id",
                        name: "repackstatusdetail",
                        component: RepackStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE REPACKSTATUS END

            // ROUTE REPACKING START
            {
                path: "/repacking",
                name: "repackingindex",
                component: RepackingIndex,// if you need change to RepackingIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/repacking/create",
                        name: "repackingcreate",
                        component: RepackingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/create/:id/copydata/:copydata",
                        name: "repackingcopydata",
                        component: RepackingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/edit/:id",
                        name: "repackingedit",
                        component: RepackingInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/detail/:id",
                        name: "repackingdetail",
                        component: RepackingDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/scan/:id",
                        name: "repackingscan",
                        component: RepackingScan,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/searchscan/:id",
                        name: "repackingscaninprogress",
                        component: RepackingSearchScan,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/repacking/searchscan",
                        name: "repackingsearchscan",
                        component: RepackingSearchScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE REPACKING END


            // ROUTE DELIVERYQUALITYINSPECTIONSTATUS START
            {
                path: "/deliveryqualityinspectionstatus",
                name: "deliveryqualityinspectionstatusindex",
                component: DeliveryQualityInspectionStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryqualityinspectionstatus/create",
                        name: "deliveryqualityinspectionstatuscreate",
                        component: DeliveryQualityInspectionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspectionstatus/create/:id/copydata/:copydata",
                        name: "deliveryqualityinspectionstatuscopydata",
                        component: DeliveryQualityInspectionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspectionstatus/edit/:id",
                        name: "deliveryqualityinspectionstatusedit",
                        component: DeliveryQualityInspectionStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspectionstatus/detail/:id",
                        name: "deliveryqualityinspectionstatusdetail",
                        component: DeliveryQualityInspectionStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYQUALITYINSPECTIONSTATUS END


            // ROUTE DELIVERYINSTRUCTION START
            {
                path: "/deliveryinstruction",
                name: "deliveryinstructionindex",
                component: DeliveryInstructionIndex,// if you need change to DeliveryInstructionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryinstruction/create",
                        name: "deliveryinstructioncreate",
                        component: DeliveryInstructionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstruction/create/:id/copydata/:copydata",
                        name: "deliveryinstructioncopydata",
                        component: DeliveryInstructionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstruction/edit/:id",
                        name: "deliveryinstructionedit",
                        component: DeliveryInstructionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstruction/detail/:id",
                        name: "deliveryinstructiondetail",
                        component: DeliveryInstructionDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYINSTRUCTION END


            // ROUTE QCSTATUS START
            {
                path: "/qcstatus",
                name: "qcstatusindex",
                component: QcStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/qcstatus/create",
                        name: "qcstatuscreate",
                        component: QcStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcstatus/create/:id/copydata/:copydata",
                        name: "qcstatuscopydata",
                        component: QcStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcstatus/edit/:id",
                        name: "qcstatusedit",
                        component: QcStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/qcstatus/detail/:id",
                        name: "qcstatusdetail",
                        component: QcStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE QCSTATUS END


            // ROUTE CONTROLCARD START
            {
                path: "/controlcard",
                name: "controlcardindex",
                component: ControlCardIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcard/create",
                        name: "controlcardcreate",
                        component: ControlCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcard/create/:id/copydata/:copydata",
                        name: "controlcardcopydata",
                        component: ControlCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcard/edit/:id",
                        name: "controlcardedit",
                        component: ControlCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcard/detail/:id",
                        name: "controlcarddetail",
                        component: ControlCardDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARD END


            // ROUTE OUTGOINGCHECKSTATUS START
            {
                path: "/outgoingcheckstatus",
                name: "outgoingcheckstatusindex",
                component: OutgoingCheckStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/outgoingcheckstatus/create",
                        name: "outgoingcheckstatuscreate",
                        component: OutgoingCheckStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheckstatus/create/:id/copydata/:copydata",
                        name: "outgoingcheckstatuscopydata",
                        component: OutgoingCheckStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheckstatus/edit/:id",
                        name: "outgoingcheckstatusedit",
                        component: OutgoingCheckStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheckstatus/detail/:id",
                        name: "outgoingcheckstatusdetail",
                        component: OutgoingCheckStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE OUTGOINGCHECKSTATUS END


            // ROUTE DELIVERYQUALITYINSPECTION START
            {
                path: "/deliveryqualityinspection",
                name: "deliveryqualityinspectionindex",
                component: DeliveryQualityInspectionIndex,// if you need change to DeliveryQualityInspectionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryqualityinspection/create",
                        name: "deliveryqualityinspectioncreate",
                        component: DeliveryQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspection/create/:id/copydata/:copydata",
                        name: "deliveryqualityinspectioncopydata",
                        component: DeliveryQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspection/edit/:id",
                        name: "deliveryqualityinspectionedit",
                        component: DeliveryQualityInspectionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspection/detail/:id",
                        name: "deliveryqualityinspectiondetail",
                        component: DeliveryQualityInspectionDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryqualityinspection/scan/:id",
                        name: "deliveryqualityinspectionscan",
                        component: DeliveryQualityInspectionScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYQUALITYINSPECTION END


            // ROUTE OUTGOINGCHECK START
            {
                path: "/outgoingcheck",
                name: "outgoingcheckindex",
                component: OutgoingCheckIndex,// if you need change to OutgoingCheckIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/outgoingcheck/create",
                        name: "outgoingcheckcreate",
                        component: OutgoingCheckInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheck/create/:id/copydata/:copydata",
                        name: "outgoingcheckcopydata",
                        component: OutgoingCheckInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheck/edit/:id",
                        name: "outgoingcheckedit",
                        component: OutgoingCheckInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheck/detail/:id",
                        name: "outgoingcheckdetail",
                        component: OutgoingCheckDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/outgoingcheck/scan/:id",
                        name: "outgoingcheckscan",
                        component: OutgoingCheckScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE OUTGOINGCHECK END

            // ROUTE CONTROLCARDFORDELIVERY START
            {
                path: "/controlcardfordelivery",
                name: "controlcardfordeliveryindex",
                component: ControlCardForDeliveryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/controlcardfordelivery/create",
                        name: "controlcardfordeliverycreate",
                        component: ControlCardForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardfordelivery/create/:id/copydata/:copydata",
                        name: "controlcardfordeliverycopydata",
                        component: ControlCardForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardfordelivery/edit/:id",
                        name: "controlcardfordeliveryedit",
                        component: ControlCardForDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/controlcardfordelivery/detail/:id",
                        name: "controlcardfordeliverydetail",
                        component: ControlCardForDeliveryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE CONTROLCARDFORDELIVERY END


            // ROUTE SURATJALANDELIVERY START
            {
                path: "/suratjalandelivery",
                name: "suratjalandeliveryindex",
                component: SuratJalanDeliveryIndex,// if you need change to SuratJalanDeliveryIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/suratjalandelivery/create",
                        name: "suratjalandeliverycreate",
                        component: SuratJalanDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandelivery/create/:id/copydata/:copydata",
                        name: "suratjalandeliverycopydata",
                        component: SuratJalanDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandelivery/edit/:id",
                        name: "suratjalandeliveryedit",
                        component: SuratJalanDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandelivery/detail/:id",
                        name: "suratjalandeliverydetail",
                        component: SuratJalanDeliveryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SURATJALANDELIVERY END

            // ROUTE SURATJALANDELIVERYSUBCON START
            {
                path: "/suratjalandeliverysubcon",
                name: "suratjalandeliverysubconindex",
                component: SuratJalanDeliverySubconIndex,// if you need change to SuratJalanDeliverySubconIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/suratjalandeliverysubcon/create",
                        name: "suratjalandeliverysubconcreate",
                        component: SuratJalanDeliverySubconInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandeliverysubcon/create/:id/copydata/:copydata",
                        name: "suratjalandeliverysubconcopydata",
                        component: SuratJalanDeliverySubconInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandeliverysubcon/edit/:id",
                        name: "suratjalandeliverysubconedit",
                        component: SuratJalanDeliverySubconInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalandeliverysubcon/detail/:id",
                        name: "suratjalandeliverysubcondetail",
                        component: SuratJalanDeliverySubconDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SURATJALANDELIVERYSUBCON END


            // ROUTE PRODUCTIONCONTROLTIME START
            {
                path: "/productioncontroltime",
                name: "productioncontroltimeindex",
                component: ProductionControlTimeIndex,// if you need change to ProductionControlTimeIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/productioncontroltime/create",
                        name: "productioncontroltimecreate",
                        component: ProductionControlTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productioncontroltime/create/:id/copydata/:copydata",
                        name: "productioncontroltimecopydata",
                        component: ProductionControlTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productioncontroltime/edit/:id",
                        name: "productioncontroltimeedit",
                        component: ProductionControlTimeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/productioncontroltime/detail/:id",
                        name: "productioncontroltimedetail",
                        component: ProductionControlTimeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PRODUCTIONCONTROLTIME END


            // ROUTE DELIVERYINSTRUCTIONDELIVERYCARD START
            {
                path: "/deliveryinstructiondeliverycard",
                name: "deliveryinstructiondeliverycardindex",
                component: DeliveryInstructionDeliveryCardIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/deliveryinstructiondeliverycard/create",
                        name: "deliveryinstructiondeliverycardcreate",
                        component: DeliveryInstructionDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructiondeliverycard/create/:id/copydata/:copydata",
                        name: "deliveryinstructiondeliverycardcopydata",
                        component: DeliveryInstructionDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructiondeliverycard/edit/:id",
                        name: "deliveryinstructiondeliverycardedit",
                        component: DeliveryInstructionDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/deliveryinstructiondeliverycard/detail/:id",
                        name: "deliveryinstructiondeliverycarddetail",
                        component: DeliveryInstructionDeliveryCardDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DELIVERYINSTRUCTIONDELIVERYCARD END

            // ROUTE WOSFORSUBCONTRACTSTATUS START
            {
                path: "/wosforsubcontractstatus",
                name: "wosforsubcontractstatusindex",
                component: WosForSubcontractStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/wosforsubcontractstatus/create",
                        name: "wosforsubcontractstatuscreate",
                        component: WosForSubcontractStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/wosforsubcontractstatus/create/:id/copydata/:copydata",
                        name: "wosforsubcontractstatuscopydata",
                        component: WosForSubcontractStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/wosforsubcontractstatus/edit/:id",
                        name: "wosforsubcontractstatusedit",
                        component: WosForSubcontractStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/wosforsubcontractstatus/detail/:id",
                        name: "wosforsubcontractstatusdetail",
                        component: WosForSubcontractStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE WOSFORSUBCONTRACTSTATUS END


            // ROUTE PARTMAPPINGSUBCONTRACT START
            {
                path: "/partmappingsubcontract",
                name: "partmappingsubcontractindex",
                component: PartMappingSubcontractIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/partmappingsubcontract/create",
                        name: "partmappingsubcontractcreate",
                        component: PartMappingSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partmappingsubcontract/create/:id/copydata/:copydata",
                        name: "partmappingsubcontractcopydata",
                        component: PartMappingSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partmappingsubcontract/edit/:id",
                        name: "partmappingsubcontractedit",
                        component: PartMappingSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/partmappingsubcontract/detail/:id",
                        name: "partmappingsubcontractdetail",
                        component: PartMappingSubcontractDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PARTMAPPINGSUBCONTRACT END


            // ROUTE WORKORDERSUPPLYSUBCONTRACT START
            {
                path: "/workordersupplysubcontract",
                name: "workordersupplysubcontractindex",
                component: WorkOrderSupplySubContractIndex,// if you need change to WorkOrderSupplySubContractIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workordersupplysubcontract/create",
                        name: "workordersupplysubcontractcreate",
                        component: WorkOrderSupplySubContractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupplysubcontract/create/:id/copydata/:copydata",
                        name: "workordersupplysubcontractcopydata",
                        component: WorkOrderSupplySubContractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupplysubcontract/edit/:id",
                        name: "workordersupplysubcontractedit",
                        component: WorkOrderSupplySubContractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/workordersupplysubcontract/detail/:id",
                        name: "workordersupplysubcontractdetail",
                        component: WorkOrderSupplySubContractDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/workordersupplysubcontract/inbox",
                name: "workordersupplysubcontractinbox",
                component: WorkOrderSupplySubContractInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/workordersupplysubcontract/createinboxrequest/:id",
                        name: "workordersupplysubcontractcreateinboxrequest",
                        component: WorkOrderSupplySubContractInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE WORKORDERSUPPLYSUBCONTRACT END


            // ROUTE DISUBCONTDELIVERYCARD START
            {
                path: "/disubcontdeliverycard",
                name: "disubcontdeliverycardindex",
                component: DiSubcontDeliveryCardIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/disubcontdeliverycard/create",
                        name: "disubcontdeliverycardcreate",
                        component: DiSubcontDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/disubcontdeliverycard/create/:id/copydata/:copydata",
                        name: "disubcontdeliverycardcopydata",
                        component: DiSubcontDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/disubcontdeliverycard/edit/:id",
                        name: "disubcontdeliverycardedit",
                        component: DiSubcontDeliveryCardInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/disubcontdeliverycard/detail/:id",
                        name: "disubcontdeliverycarddetail",
                        component: DiSubcontDeliveryCardDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE DISUBCONTDELIVERYCARD END


            // ROUTE PICKINGSUPPLYFORSUBCONTRACT START
            {
                path: "/pickingsupplyforsubcontract",
                name: "pickingsupplyforsubcontractindex",
                component: PickingSupplyForSubcontractIndex,// if you need change to PickingSupplyForSubcontractIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pickingsupplyforsubcontract/create",
                        name: "pickingsupplyforsubcontractcreate",
                        component: PickingSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforsubcontract/create/:id/copydata/:copydata",
                        name: "pickingsupplyforsubcontractcopydata",
                        component: PickingSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforsubcontract/edit/:id",
                        name: "pickingsupplyforsubcontractedit",
                        component: PickingSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforsubcontract/detail/:id",
                        name: "pickingsupplyforsubcontractdetail",
                        component: PickingSupplyForSubcontractDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pickingsupplyforsubcontract/scan/:id",
                        name: "pickingsupplyforsubcontractscan",
                        component: PickingSupplyForSubcontractScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICKINGSUPPLYFORSUBCONTRACT END

            // ROUTE SUBCONTRACTREQUESTDELIVERY START
            {
                path: "/subcontractrequestdelivery",
                name: "subcontractrequestdeliveryindex",
                component: SubcontractRequestDeliveryIndex,// if you need change to SubcontractRequestDeliveryIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/subcontractrequestdelivery/create",
                        name: "subcontractrequestdeliverycreate",
                        component: SubcontractRequestDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractrequestdelivery/create/:id/copydata/:copydata",
                        name: "subcontractrequestdeliverycopydata",
                        component: SubcontractRequestDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractrequestdelivery/edit/:id",
                        name: "subcontractrequestdeliveryedit",
                        component: SubcontractRequestDeliveryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractrequestdelivery/detail/:id",
                        name: "subcontractrequestdeliverydetail",
                        component: SubcontractRequestDeliveryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SUBCONTRACTREQUESTDELIVERY END


            // ROUTE STOCKOPNAMESTATUS START
            {
                path: "/stockopnamestatus",
                name: "stockopnamestatusindex",
                component: StockOpnameStatusIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockopnamestatus/create",
                        name: "stockopnamestatuscreate",
                        component: StockOpnameStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnamestatus/create/:id/copydata/:copydata",
                        name: "stockopnamestatuscopydata",
                        component: StockOpnameStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnamestatus/edit/:id",
                        name: "stockopnamestatusedit",
                        component: StockOpnameStatusInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnamestatus/detail/:id",
                        name: "stockopnamestatusdetail",
                        component: StockOpnameStatusDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE STOCKOPNAMESTATUS END


            // ROUTE AREA START
            {
                path: "/area",
                name: "areaindex",
                component: AreaIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/area/create",
                        name: "areacreate",
                        component: AreaInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/area/create/:id/copydata/:copydata",
                        name: "areacopydata",
                        component: AreaInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/area/edit/:id",
                        name: "areaedit",
                        component: AreaInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/area/detail/:id",
                        name: "areadetail",
                        component: AreaDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE AREA END


            // ROUTE SCRAPEXECUTION START
            {
                path: "/scrapexecution",
                name: "scrapexecutionindex",
                component: ScrapExecutionIndex,// if you need change to ScrapExecutionIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/scrapexecution/create",
                        name: "scrapexecutioncreate",
                        component: ScrapExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scrapexecution/create/:id/copydata/:copydata",
                        name: "scrapexecutioncopydata",
                        component: ScrapExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scrapexecution/edit/:id",
                        name: "scrapexecutionedit",
                        component: ScrapExecutionInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/scrapexecution/detail/:id",
                        name: "scrapexecutiondetail",
                        component: ScrapExecutionDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SCRAPEXECUTION END


            // ROUTE STOCKOPNAMEPLAN START
            {
                path: "/stockopnameplan",
                name: "stockopnameplanindex",
                component: StockOpnamePlanIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockopnameplan/create",
                        name: "stockopnameplancreate",
                        component: StockOpnamePlanInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameplan/create/:id/copydata/:copydata",
                        name: "stockopnameplancopydata",
                        component: StockOpnamePlanInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameplan/edit/:id",
                        name: "stockopnameplanedit",
                        component: StockOpnamePlanInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameplan/detail/:id",
                        name: "stockopnameplandetail",
                        component: StockOpnamePlanDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE STOCKOPNAMEPLAN END

            // ROUTE STOCKADJUSTMENTTYPE START
            {
                path: "/stockadjustmenttype",
                name: "stockadjustmenttypeindex",
                component: StockAdjustmentTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockadjustmenttype/create",
                        name: "stockadjustmenttypecreate",
                        component: StockAdjustmentTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustmenttype/create/:id/copydata/:copydata",
                        name: "stockadjustmenttypecopydata",
                        component: StockAdjustmentTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustmenttype/edit/:id",
                        name: "stockadjustmenttypeedit",
                        component: StockAdjustmentTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustmenttype/detail/:id",
                        name: "stockadjustmenttypedetail",
                        component: StockAdjustmentTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE STOCKADJUSTMENTTYPE END


            // ROUTE STOCKADJUSTMENT START
            {
                path: "/stockadjustment",
                name: "stockadjustmentindex",
                component: StockAdjustmentIndex,// if you need change to StockAdjustmentIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockadjustment/create",
                        name: "stockadjustmentcreate",
                        component: StockAdjustmentInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustment/create/:id/copydata/:copydata",
                        name: "stockadjustmentcopydata",
                        component: StockAdjustmentInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustment/edit/:id",
                        name: "stockadjustmentedit",
                        component: StockAdjustmentInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockadjustment/detail/:id",
                        name: "stockadjustmentdetail",
                        component: StockAdjustmentDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/stockadjustment/inbox",
                name: "stockadjustmentinbox",
                component: StockAdjustmentInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockadjustment/createinboxrequest/:id",
                        name: "stockadjustmentcreateinboxrequest",
                        component: StockAdjustmentInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE STOCKADJUSTMENT END

            // ROUTE SUBCONTRACTGOODRECEIPT START
            {
                path: "/subcontractgoodreceipt",
                name: "subcontractgoodreceiptindex",
                component: SubcontractGoodReceiptIndex,// if you need change to SubcontractGoodReceiptIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/subcontractgoodreceipt/create",
                        name: "subcontractgoodreceiptcreate",
                        component: SubcontractGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractgoodreceipt/create/:id/copydata/:copydata",
                        name: "subcontractgoodreceiptcopydata",
                        component: SubcontractGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractgoodreceipt/edit/:id",
                        name: "subcontractgoodreceiptedit",
                        component: SubcontractGoodReceiptInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractgoodreceipt/detail/:id",
                        name: "subcontractgoodreceiptdetail",
                        component: SubcontractGoodReceiptDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/subcontractgoodreceipt/scan/:id",
                        name: "subcontractgoodreceiptscan",
                        component: SubcontractGoodReceiptScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SUBCONTRACTGOODRECEIPT END


            // ROUTE STOCKOPNAMERESULT START
            {
                path: "/stockopnameresult",
                name: "stockopnameresultindex",
                component: StockOpnameResultIndex,// if you need change to StockOpnameResultIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockopnameresult/create",
                        name: "stockopnameresultcreate",
                        component: StockOpnameResultInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameresult/create/:id/copydata/:copydata",
                        name: "stockopnameresultcopydata",
                        component: StockOpnameResultInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameresult/edit/:id",
                        name: "stockopnameresultedit",
                        component: StockOpnameResultInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopnameresult/detail/:id",
                        name: "stockopnameresultdetail",
                        component: StockOpnameResultDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/stockopnameresult/inbox",
                name: "stockopnameresultinbox",
                component: StockOpnameResultInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockopnameresult/createinboxrequest/:id",
                        name: "stockopnameresultcreateinboxrequest",
                        component: StockOpnameResultInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE STOCKOPNAMERESULT END

            // ROUTE STOCKOPNAME START
            {
                path: "/stockopname",
                name: "stockopnameindex",
                component: StockOpnameIndex,// if you need change to StockOpnameIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/stockopname/create",
                        name: "stockopnamecreate",
                        component: StockOpnameInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopname/create/:id/copydata/:copydata",
                        name: "stockopnamecopydata",
                        component: StockOpnameInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopname/edit/:id",
                        name: "stockopnameedit",
                        component: StockOpnameInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopname/detail/:id",
                        name: "stockopnamedetail",
                        component: StockOpnameDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/stockopname/scan/:id",
                        name: "stockopnamescan",
                        component: StockOpnameScan,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE STOCKOPNAME END

            // ROUTE SURATJALANSUPPLYFORSUBCONTRACT START
            {
                path: "/suratjalansupplyforsubcontract",
                name: "suratjalansupplyforsubcontractindex",
                component: SuratJalanSupplyForSubcontractIndex,// if you need change to SuratJalanSupplyForSubcontractIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/suratjalansupplyforsubcontract/create",
                        name: "suratjalansupplyforsubcontractcreate",
                        component: SuratJalanSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalansupplyforsubcontract/create/:id/copydata/:copydata",
                        name: "suratjalansupplyforsubcontractcopydata",
                        component: SuratJalanSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalansupplyforsubcontract/edit/:id",
                        name: "suratjalansupplyforsubcontractedit",
                        component: SuratJalanSupplyForSubcontractInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/suratjalansupplyforsubcontract/detail/:id",
                        name: "suratjalansupplyforsubcontractdetail",
                        component: SuratJalanSupplyForSubcontractDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE SURATJALANSUPPLYFORSUBCONTRACT END


            // ROUTE ANDONQC START
            {
                path: "/andonQc",
                name: "andonqcdashboard",
                component: AndonQCDashboard,
                beforeEnter: authGuard,
            },

            // ROUTE ANDONQC END

            // ROUTE ANDONPRODUCTION START
            {
                path: "/andonProduction",
                name: "andonproductiondashboard",
                component: AndonProductionDashboard,
                beforeEnter: authGuard,
            },

            // ROUTE ANDONPRODUCTION END

            // ROUTE DATASOURCE START
            {
                path: "/datasource",
                name: "datasourceindex",
                component: DataSourceIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/datasource/create",
                        name: "datasourcecreate",
                        component: DataSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/datasource/create/:id/copydata/:copydata",
                        name: "datasourcecopydata",
                        component: DataSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/datasource/edit/:id",
                        name: "datasourceedit",
                        component: DataSourceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/datasource/detail/:id",
                        name: "datasourcedetail",
                        component: DataSourceDetail,
                        beforeEnter: authGuard
                    }
                ]
            },
            // ROUTE DATASOURCE END

            // ROUTE MAINTENANCEHISTORY START
            {
                path: "/maintenancehistory",
                name: "maintenancehistoryindex",
                component: MaintenanceHistoryIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/maintenancehistory/create",
                        name: "maintenancehistorycreate",
                        component: MaintenanceHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/maintenancehistory/create/:id/copydata/:copydata",
                        name: "maintenancehistorycopydata",
                        component: MaintenanceHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/maintenancehistory/edit/:id",
                        name: "maintenancehistoryedit",
                        component: MaintenanceHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/maintenancehistory/detail/:id",
                        name: "maintenancehistorydetail",
                        component: MaintenanceHistoryDetail,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/maintenancehistory/createreport/:woeid",
                        name: "maintenancehistorycreatereport",
                        component: MaintenanceHistoryInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/maintenancehistory/detail/:fromreportid",
                        name: "maintenancehistorydetailreport",
                        component: MaintenanceHistoryDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE MAINTENANCEHISTORY END

            // ROUTE USERSIGNATURE START
            {
                path: "/usersignature",
                name: "usersignatureindex",
                component: UserSignatureIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/usersignature/create",
                        name: "usersignaturecreate",
                        component: UserSignatureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/usersignature/create/:id/copydata/:copydata",
                        name: "usersignaturecopydata",
                        component: UserSignatureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/usersignature/edit/:id",
                        name: "usersignatureedit",
                        component: UserSignatureInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/usersignature/detail/:id",
                        name: "usersignaturedetail",
                        component: UserSignatureDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE USERSIGNATURE END

            // ROUTE PICTYPE START
            {
                path: "/pictype",
                name: "pictypeindex",
                component: PicTypeIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/pictype/create",
                        name: "pictypecreate",
                        component: PicTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pictype/create/:id/copydata/:copydata",
                        name: "pictypecopydata",
                        component: PicTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pictype/edit/:id",
                        name: "pictypeedit",
                        component: PicTypeInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/pictype/detail/:id",
                        name: "pictypedetail",
                        component: PicTypeDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PICTYPE END

            // ROUTE PRINTERINFORMATION START
            {
                path: "/printerinformation",
                name: "printerinformationindex",
                component: PrinterInformationIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/printerinformation/create",
                        name: "printerinformationcreate",
                        component: PrinterInformationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/printerinformation/create/:id/copydata/:copydata",
                        name: "printerinformationcopydata",
                        component: PrinterInformationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/printerinformation/edit/:id",
                        name: "printerinformationedit",
                        component: PrinterInformationInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/printerinformation/detail/:id",
                        name: "printerinformationdetail",
                        component: PrinterInformationDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE PRINTERINFORMATION END

            // ROUTE MOBILEDEVICE START
            {
                path: "/mobiledevice",
                name: "mobiledeviceindex",
                component: MobileDeviceIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/mobiledevice/create",
                        name: "mobiledevicecreate",
                        component: MobileDeviceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/mobiledevice/create/:id/copydata/:copydata",
                        name: "mobiledevicecopydata",
                        component: MobileDeviceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/mobiledevice/edit/:id",
                        name: "mobiledeviceedit",
                        component: MobileDeviceInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/mobiledevice/detail/:id",
                        name: "mobiledevicedetail",
                        component: MobileDeviceDetail,
                        beforeEnter: authGuard
                    }
                ]
            },

            {
                path: '/mydeviceprofile',
                name: 'mydeviceprofile',
                component: MobileDeviceDetail,
                beforeEnter: authGuard
            },

            // ROUTE MOBILEDEVICE END

            // ROUTE FINISHGOODQUALITYINSPECTINBOX START
            {
                path: "/finishgoodqualityinspectinbox",
                name: "finishgoodqualityinspectinboxindex",
                component: FinishGoodQualityInspectInboxIndex,// if you need change to FinishGoodQualityInspectInboxIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/finishgoodqualityinspectinbox/create",
                        name: "finishgoodqualityinspectinboxcreate",
                        component: FinishGoodQualityInspectInboxInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspectinbox/create/:id/copydata/:copydata",
                        name: "finishgoodqualityinspectinboxcopydata",
                        component: FinishGoodQualityInspectInboxInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspectinbox/edit/:id",
                        name: "finishgoodqualityinspectinboxedit",
                        component: FinishGoodQualityInspectInboxInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/finishgoodqualityinspectinbox/detail/:id",
                        name: "finishgoodqualityinspectinboxdetail",
                        component: FinishGoodQualityInspectInboxDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            {
                path: "/finishgoodqualityinspectinbox/inbox",
                name: "finishgoodqualityinspectinboxinbox",
                component: FinishGoodQualityInspectInboxInbox,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/finishgoodqualityinspectinbox/createinboxrequest/:id",
                        name: "finishgoodqualityinspectinboxcreateinboxrequest",
                        component: FinishGoodQualityInspectInboxInputSubmission,
                        beforeEnter: authGuard,
                    },
                ]
            },

            // ROUTE FINISHGOODQUALITYINSPECTINBOX END

            // ROUTE RACK START
            {
                path: "/rack",
                name: "rackindex",
                component: RackIndex,
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/rack/create",
                        name: "rackcreate",
                        component: RackInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rack/create/:id/copydata/:copydata",
                        name: "rackcopydata",
                        component: RackInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rack/edit/:id",
                        name: "rackedit",
                        component: RackInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/rack/detail/:id",
                        name: "rackdetail",
                        component: RackDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE ANDONSTOCK START
            {
                path: "/andonStock",
                name: "andonstockdashboard",
                component: AndonStockDashboard,
                beforeEnter: authGuard,
            },

            // ROUTE ANDONSTOCK END


            // ROUTE ANDONDELIVERY START
            {
                path: "/andonDelivery",
                name: "andondeliverydashboard",
                component: AndonDeliveryDashboard,
                beforeEnter: authGuard,
            },

            // ROUTE ANDONDELIVERY END

            // ROUTE ANDONWIP START
            {
                path: "/andonWip",
                name: "andonwipdashboard",
                component: AndonWIPDashboard,
                beforeEnter: authGuard,
            },

            // ROUTE ANDONWIP END
            // ROUTE RACK END


            // ROUTE REPORTREKAPDELIVERY START
            {
                path: "/reportrekapdelivery",
                name: "reportrekapdeliveryindex",
                component: ReportRekapDeliveryIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTREKAPDELIVERY END

            // ROUTE REPORTPOSALES START
            {
                path: "/reportposales",
                name: "reportposalesindex",
                component: ReportPoSalesIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTPOSALES END

            // ROUTE REPORTPOPEMBELIAN START
            {
                path: "/reportpopembelian",
                name: "reportpopembelianindex",
                component: ReportPoPembelianIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTPOPEMBELIAN END

            // ROUTE REPORTTRACINGABILITY START
            {
                path: "/reporttracingability",
                name: "reporttracingabilityindex",
                component: ReportTracingAbilityIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTTRACINGABILITY END

            // ROUTE REPORTSTOCKCARD START
            {
                path: "/reportstockcard",
                name: "reportstockcardindex",
                component: ReportStockCardIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTSTOCKCARD END


            // ROUTE REPORTDAILYPRODUCTION START
            {
                path: "/reportdailyproduction",
                name: "reportdailyproductionindex",
                component: ReportDailyProductionIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTDAILYPRODUCTION END


            // ROUTE REPORTSUMMARYNG START
            {
                path: "/reportsummaryng",
                name: "reportsummaryngindex",
                component: ReportSummaryNGIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTSUMMARYNG END

            // ROUTE REPORTMTTR START
            {
                path: "/reportmttr",
                name: "reportmttrindex",
                component: ReportMTTRIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTMTTR END

            // ROUTE REPORTMTBF START
            {
                path: "/reportmtbf",
                name: "reportmtbfindex",
                component: ReportMTBFIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTMTBF END

            // ROUTE REPORTNG START
            {
                path: "/reportng",
                name: "reportngindex",
                component: ReportNgIndex,
                beforeEnter: authGuard,
            },

            // ROUTE REPORTSUMMARYNG END

            // ROUTE REPORTINCOMING START
            {
                path: "/reportincoming",
                name: "reportincomingindex",
                component: ReportIncomingIndex,
                beforeEnter: authGuard,
            },
            // ROUTE REPORTINCOMING END

            // ROUTE LOOKUP START
            {
                path: "/lookup",
                name: "lookupindex",
                component: LookupIndex,// if you need change to LookupIndexDetail 
                beforeEnter: authGuard,
                children: [
                    {
                        path: "/lookup/create",
                        name: "lookupcreate",
                        component: LookupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/lookup/create/:id/copydata/:copydata",
                        name: "lookupcopydata",
                        component: LookupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/lookup/edit/:id",
                        name: "lookupedit",
                        component: LookupInput,
                        beforeEnter: authGuard
                    },
                    {
                        path: "/lookup/detail/:id",
                        name: "lookupdetail",
                        component: LookupDetail,
                        beforeEnter: authGuard
                    },
                ]
            },
            // ROUTE LOOKUP END

            // ROUTE AUDITLOGIN START
            {
                path: "/auditlogin",
                name: "auditloginindex",
                component: AuditLoginIndex,
                beforeEnter: authGuard,
                children: [
                    // {
                    // 	path: "/auditlogin/create",
                    // 	name: "auditlogincreate",
                    // 	component: AuditLoginInput,
                    // 	beforeEnter: authGuard
                    // },
                    // {
                    // 	path: "/auditlogin/create/:id/copydata/:copydata",
                    // 	name: "auditlogincopydata",
                    // 	component: AuditLoginInput,
                    // 	beforeEnter: authGuard
                    // },
                    // {
                    // 	path: "/auditlogin/edit/:id",
                    // 	name: "auditloginedit",
                    // 	component: AuditLoginInput,
                    // 	beforeEnter: authGuard
                    // },
                    {
                        path: "/auditlogin/detail/:id",
                        name: "auditlogindetail",
                        component: AuditLoginDetail,
                        beforeEnter: authGuard
                    },
                ]
            },

            // ROUTE AUDITLOGIN END
			

            // ROUTE ANDONPRODUCTION START
            {
                path: "/andonProduction",
                name: "andonproductiondashboard",
                component: AndonProductionDashboard,
                beforeEnter: authGuard,
            },

            
		// ROUTE VENDORSCRAP START
{
			path : "/vendorscrap",
			name: "vendorscrapindex",
			component: VendorScrapIndex,
			beforeEnter: authGuard,
			children: [
				{
					path: "/vendorscrap/create",
					name: "vendorscrapcreate",
					component: VendorScrapInput,
					beforeEnter: authGuard
				},
				{
					path: "/vendorscrap/create/:id/copydata/:copydata",
					name: "vendorscrapcopydata",
					component: VendorScrapInput,
					beforeEnter: authGuard
				},
				{
					path: "/vendorscrap/edit/:id",
					name: "vendorscrapedit",
					component: VendorScrapInput,
					beforeEnter: authGuard
				},
				{
					path: "/vendorscrap/detail/:id",
					name: "vendorscrapdetail",
					component: VendorScrapDetail,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE VENDORSCRAP END
		
		// ROUTE MAPPINGANDONPRODUCTION START
{
			path : "/mappingandonproduction",
			name: "mappingandonproductionindex",
			component: MappingAndonProductionIndex,// if you need change to MappingAndonProductionIndexDetail 
			beforeEnter: authGuard,
			children: [
				{
					path: "/mappingandonproduction/create",
					name: "mappingandonproductioncreate",
					component: MappingAndonProductionInput,
					beforeEnter: authGuard
				},
				{
					path: "/mappingandonproduction/create/:id/copydata/:copydata",
					name: "mappingandonproductioncopydata",
					component: MappingAndonProductionInput,
					beforeEnter: authGuard
				},
				{
					path: "/mappingandonproduction/edit/:id",
					name: "mappingandonproductionedit",
					component: MappingAndonProductionInput,
					beforeEnter: authGuard
				},
				{
					path: "/mappingandonproduction/detail/:id",
					name: "mappingandonproductiondetail",
					component: MappingAndonProductionDetail,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE MAPPINGANDONPRODUCTION END
		
		
		
		// ROUTE BERITAACARASTOCKOPNAME START
{
			path : "/beritaacarastockopname",
			name: "beritaacarastockopnameindex",
			component: BeritaAcaraStockOpnameIndex,
			beforeEnter: authGuard,
			children: [
				{
					path: "/beritaacarastockopname/create",
					name: "beritaacarastockopnamecreate",
					component: BeritaAcaraStockOpnameInput,
					beforeEnter: authGuard
				},
				{
					path: "/beritaacarastockopname/create/:id/copydata/:copydata",
					name: "beritaacarastockopnamecopydata",
					component: BeritaAcaraStockOpnameInput,
					beforeEnter: authGuard
				},
				{
					path: "/beritaacarastockopname/edit/:id",
					name: "beritaacarastockopnameedit",
					component: BeritaAcaraStockOpnameInput,
					beforeEnter: authGuard
				},
				{
					path: "/beritaacarastockopname/detail/:id",
					name: "beritaacarastockopnamedetail",
					component: BeritaAcaraStockOpnameDetail,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE BERITAACARASTOCKOPNAME END
		
		
		// ROUTE PUTAWAYCONFIGURATION START
{
			path : "/putawayconfiguration",
			name: "putawayconfigurationindex",
			component: PutawayConfigurationIndex,
			beforeEnter: authGuard,
			children: [
				{
					path: "/putawayconfiguration/create",
					name: "putawayconfigurationcreate",
					component: PutawayConfigurationInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayconfiguration/create/:id/copydata/:copydata",
					name: "putawayconfigurationcopydata",
					component: PutawayConfigurationInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayconfiguration/edit/:id",
					name: "putawayconfigurationedit",
					component: PutawayConfigurationInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayconfiguration/detail/:id",
					name: "putawayconfigurationdetail",
					component: PutawayConfigurationDetail,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE PUTAWAYCONFIGURATION END
		
		// ROUTE REPORTTRACINGABILITYBACKWARD START
{
			path : "/reporttracingabilitybackward",
			name: "reporttracingabilitybackwardindex",
			component: ReportTracingAbilityBackwardIndex,
			beforeEnter: authGuard,
		},

		// ROUTE REPORTTRACINGABILITYBACKWARD END
		
		// ROUTE REPORTTRACINGABILITYDETAIL START
{
			path : "/reporttracingabilitydetail",
			name: "reporttracingabilitydetailindex",
			component: ReportTracingAbilityDetailIndex,
			beforeEnter: authGuard,
		},

		// ROUTE REPORTTRACINGABILITYDETAIL END
		
		// ROUTE REPORTDELAYDELIVERYINSTRUCTION START
{
			path : "/reportdelaydeliveryinstruction",
			name: "reportdelaydeliveryinstructionindex",
			component: ReportDelayDeliveryInstructionIndex,
			beforeEnter: authGuard,
		},

		// ROUTE REPORTDELAYDELIVERYINSTRUCTION END
		
		
		// ROUTE PUTAWAYHEADER START
{
			path : "/putawayheader",
			name: "putawayheaderindex",
			component: PutawayHeaderIndex,
			beforeEnter: authGuard,
			children: [
				{
					path: "/putawayheader/create",
					name: "putawayheadercreate",
					component: PutawayHeaderInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayheader/create/:id/copydata/:copydata",
					name: "putawayheadercopydata",
					component: PutawayHeaderInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayheader/edit/:id",
					name: "putawayheaderedit",
					component: PutawayHeaderInput,
					beforeEnter: authGuard
				},
				{
					path: "/putawayheader/detail/:id",
					name: "putawayheaderdetail",
					component: PutawayHeaderDetail,
					beforeEnter: authGuard
				},
				{
					path: "/putawayheader/scan",
					name: "putawayheaderscan",
					component: PutawayHeaderScan,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE PUTAWAYHEADER END
		
		
		// ROUTE FINISHGOODQCCONFIRMATION START
{
			path : "/finishgoodqcconfirmation",
			name: "finishgoodqcconfirmationindex",
			component: FinishGoodQcConfirmationIndex,// if you need change to FinishGoodQcConfirmationIndexDetail 
			beforeEnter: authGuard,
			children: [
				{
					path: "/finishgoodqcconfirmation/create",
					name: "finishgoodqcconfirmationcreate",
					component: FinishGoodQcConfirmationInput,
					beforeEnter: authGuard
				},
				{
					path: "/finishgoodqcconfirmation/create/:id/copydata/:copydata",
					name: "finishgoodqcconfirmationcopydata",
					component: FinishGoodQcConfirmationInput,
					beforeEnter: authGuard
				},
				{
					path: "/finishgoodqcconfirmation/edit/:id",
					name: "finishgoodqcconfirmationedit",
					component: FinishGoodQcConfirmationInput,
					beforeEnter: authGuard
				},
				{
					path: "/finishgoodqcconfirmation/detail/:id",
					name: "finishgoodqcconfirmationdetail",
					component: FinishGoodQcConfirmationDetail,
					beforeEnter: authGuard
				},
			]
		},
		{
			path: "/finishgoodqcconfirmation/inbox",
			name: "finishgoodqcconfirmationinbox",
			component: FinishGoodQcConfirmationInbox,
			beforeEnter: authGuard,
			children: [
				{
					path: "/finishgoodqcconfirmation/createinboxrequest/:id",
					name: "finishgoodqcconfirmationcreateinboxrequest",
					component: FinishGoodQcConfirmationInputSubmission,
					beforeEnter: authGuard,
				},
			]
		},

		// ROUTE FINISHGOODQCCONFIRMATION END
		
		// ROUTE WORKORDEREXECUTIONHOLDTIME START
{
			path : "/workorderexecutionholdtime",
			name: "workorderexecutionholdtimeindex",
			component: WorkOrderExecutionHoldTimeIndex,
			beforeEnter: authGuard,
			children: [
				{
					path: "/workorderexecutionholdtime/create",
					name: "workorderexecutionholdtimecreate",
					component: WorkOrderExecutionHoldTimeInput,
					beforeEnter: authGuard
				},
				{
					path: "/workorderexecutionholdtime/create/:id/copydata/:copydata",
					name: "workorderexecutionholdtimecopydata",
					component: WorkOrderExecutionHoldTimeInput,
					beforeEnter: authGuard
				},
				{
					path: "/workorderexecutionholdtime/edit/:id",
					name: "workorderexecutionholdtimeedit",
					component: WorkOrderExecutionHoldTimeInput,
					beforeEnter: authGuard
				},
				{
					path: "/workorderexecutionholdtime/detail/:id",
					name: "workorderexecutionholdtimedetail",
					component: WorkOrderExecutionHoldTimeDetail,
					beforeEnter: authGuard
				},
			]
		},

		// ROUTE WORKORDEREXECUTIONHOLDTIME END
		//ENDROUTE
        ]
    }
)
